// import axios from "axios";
// import React, { useCallback, useEffect, useState } from "react";
// import { IoClose, IoAddCircleOutline } from "react-icons/io5";
// import "./EnglishCours.css";

// const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
// const BASE = `${API_BASE_URL}/admin/english-course`;

// const LEVEL_SLUGS = ["beginner", "intermediate", "advanced"];
// const VIDEO_MIMES = ["video/mp4", "video/webm", "video/quicktime", "video/x-m4v"];

// const EMPTY_LEVEL = {
//   slug: "beginner",
//   title: "",
//   description: "",
//   price: "",
//   coverImage: "",
//   displayOrder: 0,
//   isPublished: false,
// };

// const EMPTY_LESSON = {
//   title: "",
//   description: "",
//   lessonNumber: 1,
//   thumbnailUrl: "",
//   videoStorageKey: "",
//   originalFileName: "",
//   videoMimeType: "video/mp4",
//   videoSizeBytes: "",
//   durationSeconds: 0,
//   isPublished: false,
// };

// const authHeaders = () => ({
//   headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
// });

// const errMsg = (error, fallback = "Something went wrong. Please try again.") =>
//   error?.response?.data?.message || fallback;

// const formatPrice = (price, currency = "INR") =>
//   new Intl.NumberFormat("en-IN", {
//     style: "currency",
//     currency,
//     maximumFractionDigits: 0,
//   }).format(price || 0);

// const formatDuration = (sec) => {
//   const s = Math.round(Number(sec) || 0);
//   if (!s) return "--";
//   const m = Math.floor(s / 60);
//   const r = s % 60;
//   return `${m}:${String(r).padStart(2, "0")}`;
// };

// const formatSize = (bytes) => {
//   const b = Number(bytes) || 0;
//   if (!b) return "--";
//   if (b < 1024 * 1024) return `${(b / 1024).toFixed(0)} KB`;
//   if (b < 1024 * 1024 * 1024) return `${(b / (1024 * 1024)).toFixed(1)} MB`;
//   return `${(b / (1024 * 1024 * 1024)).toFixed(2)} GB`;
// };

// const EnglishCours = () => {
//   // ---------- shared ----------
//   const [toast, setToast] = useState(null); // { type, text }

//   const showToast = (type, text) => {
//     setToast({ type, text });
//     setTimeout(() => setToast(null), 3500);
//   };

//   // ---------- levels ----------
//   const [levels, setLevels] = useState([]);
//   const [levelsLoading, setLevelsLoading] = useState(true);
//   const [levelsError, setLevelsError] = useState("");

//   const [levelModalOpen, setLevelModalOpen] = useState(false);
//   const [editingLevelId, setEditingLevelId] = useState(null);
//   const [levelForm, setLevelForm] = useState(EMPTY_LEVEL);
//   const [levelErrors, setLevelErrors] = useState({});
//   const [levelSaving, setLevelSaving] = useState(false);

//   const [priceModal, setPriceModal] = useState(null); // { id, title, price }
//   const [priceSaving, setPriceSaving] = useState(false);
//   const [priceError, setPriceError] = useState("");

//   // ---------- lessons ----------
//   const [selectedLevel, setSelectedLevel] = useState(null);
//   const [lessons, setLessons] = useState([]);
//   const [lessonsLoading, setLessonsLoading] = useState(false);
//   const [lessonsError, setLessonsError] = useState("");

//   const [lessonModalOpen, setLessonModalOpen] = useState(false);
//   const [editingLessonId, setEditingLessonId] = useState(null);
//   const [lessonForm, setLessonForm] = useState(EMPTY_LESSON);
//   const [lessonErrors, setLessonErrors] = useState({});
//   const [lessonSaving, setLessonSaving] = useState(false);

//   // ============================================================
//   // FETCH
//   // ============================================================
//   const fetchLevels = useCallback(async () => {
//     try {
//       setLevelsLoading(true);
//       const res = await axios.get(`${BASE}/levels`, authHeaders());
//       const data = res.data?.data || [];
//       setLevels(data);
//       setLevelsError("");
//       // keep the selected level's details fresh
//       setSelectedLevel((prev) =>
//         prev ? data.find((l) => l._id === prev._id) || null : prev
//       );
//     } catch (error) {
//       console.log(error);
//       setLevelsError(errMsg(error, "Couldn't load levels. Please refresh."));
//     } finally {
//       setLevelsLoading(false);
//     }
//   }, []);

//   const fetchLessons = useCallback(async (levelId) => {
//     if (!levelId) return;
//     try {
//       setLessonsLoading(true);
//       const res = await axios.get(`${BASE}/levels/${levelId}/lessons`, authHeaders());
//       setLessons(res.data?.data || []);
//       setLessonsError("");
//     } catch (error) {
//       console.log(error);
//       setLessonsError(errMsg(error, "Couldn't load lessons."));
//     } finally {
//       setLessonsLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchLevels();
//   }, [fetchLevels]);

//   useEffect(() => {
//     if (selectedLevel?._id) fetchLessons(selectedLevel._id);
//     else setLessons([]);
//   }, [selectedLevel?._id, fetchLessons]);

//   // ============================================================
//   // LEVEL ACTIONS
//   // ============================================================
//   const openCreateLevel = () => {
//     const used = levels.map((l) => l.slug);
//     const firstFree = LEVEL_SLUGS.find((s) => !used.includes(s)) || "beginner";
//     setEditingLevelId(null);
//     setLevelForm({ ...EMPTY_LEVEL, slug: firstFree, displayOrder: levels.length });
//     setLevelErrors({});
//     setLevelModalOpen(true);
//   };

//   const openEditLevel = (level) => {
//     setEditingLevelId(level._id);
//     setLevelForm({
//       slug: level.slug,
//       title: level.title || "",
//       description: level.description || "",
//       price: level.price ?? "",
//       coverImage: level.coverImage || "",
//       displayOrder: level.displayOrder ?? 0,
//       isPublished: !!level.isPublished,
//     });
//     setLevelErrors({});
//     setLevelModalOpen(true);
//   };

//   const handleLevelChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setLevelForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
//   };

//   const validateLevel = () => {
//     const e = {};
//     if (!editingLevelId && !LEVEL_SLUGS.includes(levelForm.slug))
//       e.slug = "Choose a valid level.";
//     if (!levelForm.title.trim()) e.title = "Title is required.";
//     else if (levelForm.title.length > 120) e.title = "Max 120 characters.";
//     if (
//       !editingLevelId &&
//       (levelForm.price === "" ||
//         !Number.isFinite(Number(levelForm.price)) ||
//         Number(levelForm.price) < 0)
//     )
//       e.price = "Enter a valid price (0 or more).";
//     if (
//       levelForm.displayOrder === "" ||
//       !Number.isFinite(Number(levelForm.displayOrder)) ||
//       Number(levelForm.displayOrder) < 0
//     )
//       e.displayOrder = "Must be 0 or more.";
//     setLevelErrors(e);
//     return Object.keys(e).length === 0;
//   };

//   const submitLevel = async (e) => {
//     e.preventDefault();
//     if (!validateLevel()) return;

//     try {
//       setLevelSaving(true);
//       if (editingLevelId) {
//         // price is changed through its own endpoint, slug is immutable
//         const payload = {
//           title: levelForm.title.trim(),
//           description: levelForm.description.trim(),
//           coverImage: levelForm.coverImage.trim(),
//           displayOrder: Number(levelForm.displayOrder),
//           isPublished: levelForm.isPublished,
//         };
//         await axios.patch(`${BASE}/levels/${editingLevelId}`, payload, authHeaders());
//         showToast("success", "Level updated.");
//       } else {
//         const payload = {
//           slug: levelForm.slug,
//           title: levelForm.title.trim(),
//           description: levelForm.description.trim(),
//           price: Number(levelForm.price),
//           currency: "INR",
//           coverImage: levelForm.coverImage.trim(),
//           displayOrder: Number(levelForm.displayOrder),
//           isPublished: levelForm.isPublished,
//         };
//         await axios.post(`${BASE}/levels`, payload, authHeaders());
//         showToast("success", "Level created.");
//       }
//       setLevelModalOpen(false);
//       fetchLevels();
//     } catch (error) {
//       console.log(error);
//       setLevelErrors({ submit: errMsg(error) });
//     } finally {
//       setLevelSaving(false);
//     }
//   };

//   const toggleLevelPublish = async (level) => {
//     try {
//       await axios.patch(
//         `${BASE}/levels/${level._id}`,
//         { isPublished: !level.isPublished },
//         authHeaders()
//       );
//       showToast("success", level.isPublished ? "Level unpublished." : "Level published.");
//       fetchLevels();
//     } catch (error) {
//       console.log(error);
//       showToast("error", errMsg(error, "Failed to change publish status."));
//     }
//   };

//   const submitPrice = async (e) => {
//     e.preventDefault();
//     const val = priceModal.price;
//     if (val === "" || !Number.isFinite(Number(val)) || Number(val) < 0) {
//       setPriceError("Enter a valid price (0 or more).");
//       return;
//     }
//     try {
//       setPriceSaving(true);
//       await axios.patch(
//         `${BASE}/levels/${priceModal.id}/price`,
//         { price: Number(val) },
//         authHeaders()
//       );
//       setPriceModal(null);
//       setPriceError("");
//       showToast("success", "Price updated.");
//       fetchLevels();
//     } catch (error) {
//       console.log(error);
//       setPriceError(errMsg(error));
//     } finally {
//       setPriceSaving(false);
//     }
//   };

//   const deleteLevel = async (level) => {
//     if (!window.confirm(`Delete "${level.title}"? This cannot be undone.`)) return;
//     try {
//       const res = await axios.delete(`${BASE}/levels/${level._id}`, authHeaders());
//       showToast("success", res.data?.message || "Level deleted.");
//       if (selectedLevel?._id === level._id) setSelectedLevel(null);
//       fetchLevels();
//     } catch (error) {
//       console.log(error);
//       showToast("error", errMsg(error, "Failed to delete level."));
//     }
//   };

//   // ============================================================
//   // LESSON ACTIONS
//   // ============================================================
//   const openCreateLesson = () => {
//     const nextNumber = lessons.length
//       ? Math.max(...lessons.map((l) => Number(l.lessonNumber) || 0)) + 1
//       : 1;
//     setEditingLessonId(null);
//     setLessonForm({ ...EMPTY_LESSON, lessonNumber: nextNumber });
//     setLessonErrors({});
//     setLessonModalOpen(true);
//   };

//   const openEditLesson = (lesson) => {
//     setEditingLessonId(lesson._id);
//     setLessonForm({
//       title: lesson.title || "",
//       description: lesson.description || "",
//       lessonNumber: lesson.lessonNumber ?? 1,
//       thumbnailUrl: lesson.thumbnailUrl || "",
//       videoStorageKey: "", // never returned by the API, cannot be edited here
//       originalFileName: lesson.originalFileName || "",
//       videoMimeType: lesson.videoMimeType || "video/mp4",
//       videoSizeBytes: lesson.videoSizeBytes ?? "",
//       durationSeconds: lesson.durationSeconds ?? 0,
//       isPublished: !!lesson.isPublished,
//     });
//     setLessonErrors({});
//     setLessonModalOpen(true);
//   };

//   const handleLessonChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setLessonForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
//   };

//   // Fill filename / mime / size / duration from a picked video file.
//   // The file itself is NOT uploaded here — only its metadata is read.
//   const handleVideoPick = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     setLessonForm((p) => ({
//       ...p,
//       originalFileName: file.name,
//       videoMimeType: VIDEO_MIMES.includes(file.type) ? file.type : p.videoMimeType,
//       videoSizeBytes: file.size,
//     }));

//     const url = URL.createObjectURL(file);
//     const video = document.createElement("video");
//     video.preload = "metadata";
//     video.onloadedmetadata = () => {
//       setLessonForm((p) => ({
//         ...p,
//         durationSeconds: Math.round(video.duration || 0),
//       }));
//       URL.revokeObjectURL(url);
//     };
//     video.onerror = () => URL.revokeObjectURL(url);
//     video.src = url;
//   };

//   const validateLesson = () => {
//     const e = {};
//     const f = lessonForm;
//     if (!f.title.trim()) e.title = "Title is required.";
//     else if (f.title.length > 200) e.title = "Max 200 characters.";

//     if (!editingLessonId) {
//       const key = f.videoStorageKey.trim();
//       if (!key) e.videoStorageKey = "Private video storage key is required.";
//       else if (
//         key.includes("..") ||
//         key.includes("\\") ||
//         key.startsWith("/") ||
//         /^[a-z]+:\/\//i.test(key)
//       )
//         e.videoStorageKey = "Use a storage key, not a URL or file path.";
//     }

//     if (!f.originalFileName.trim()) e.originalFileName = "File name is required.";
//     if (!VIDEO_MIMES.includes(f.videoMimeType)) e.videoMimeType = "Unsupported format.";
//     if (!Number.isFinite(Number(f.videoSizeBytes)) || Number(f.videoSizeBytes) <= 0)
//       e.videoSizeBytes = "Size must be greater than zero.";
//     if (!Number.isInteger(Number(f.lessonNumber)) || Number(f.lessonNumber) < 1)
//       e.lessonNumber = "Must be a positive whole number.";
//     if (!Number.isFinite(Number(f.durationSeconds)) || Number(f.durationSeconds) < 0)
//       e.durationSeconds = "Must be 0 or more.";

//     setLessonErrors(e);
//     return Object.keys(e).length === 0;
//   };

//   const submitLesson = async (e) => {
//     e.preventDefault();
//     if (!validateLesson()) return;

//     const f = lessonForm;
//     const common = {
//       title: f.title.trim(),
//       description: f.description.trim(),
//       originalFileName: f.originalFileName.trim(),
//       videoMimeType: f.videoMimeType,
//       videoSizeBytes: Number(f.videoSizeBytes),
//       durationSeconds: Number(f.durationSeconds),
//       thumbnailUrl: f.thumbnailUrl.trim(),
//       lessonNumber: Number(f.lessonNumber),
//       isPublished: f.isPublished,
//     };

//     try {
//       setLessonSaving(true);
//       if (editingLessonId) {
//         await axios.patch(`${BASE}/lessons/${editingLessonId}`, common, authHeaders());
//         showToast("success", "Lesson updated.");
//       } else {
//         await axios.post(
//           `${BASE}/levels/${selectedLevel._id}/lessons`,
//           { ...common, videoStorageKey: f.videoStorageKey.trim() },
//           authHeaders()
//         );
//         showToast("success", "Lesson created.");
//       }
//       setLessonModalOpen(false);
//       fetchLessons(selectedLevel._id);
//     } catch (error) {
//       console.log(error);
//       setLessonErrors({ submit: errMsg(error) });
//     } finally {
//       setLessonSaving(false);
//     }
//   };

//   const toggleLessonPublish = async (lesson) => {
//     try {
//       await axios.patch(
//         `${BASE}/lessons/${lesson._id}`,
//         { isPublished: !lesson.isPublished },
//         authHeaders()
//       );
//       setLessons((prev) =>
//         prev.map((l) =>
//           l._id === lesson._id ? { ...l, isPublished: !l.isPublished } : l
//         )
//       );
//     } catch (error) {
//       console.log(error);
//       showToast("error", errMsg(error, "Failed to change publish status."));
//     }
//   };

//   const deleteLesson = async (lesson) => {
//     if (
//       !window.confirm(
//         `Delete lesson "${lesson.title}"? Student progress for it will be removed.`
//       )
//     )
//       return;
//     try {
//       await axios.delete(`${BASE}/lessons/${lesson._id}`, authHeaders());
//       setLessons((prev) => prev.filter((l) => l._id !== lesson._id));
//       showToast("success", "Lesson deleted.");
//     } catch (error) {
//       console.log(error);
//       showToast("error", errMsg(error, "Failed to delete lesson."));
//     }
//   };

//   // ============================================================
//   // RENDER
//   // ============================================================
//   const allSlugsUsed = LEVEL_SLUGS.every((s) => levels.some((l) => l.slug === s));

//   return (
//     <div id="add-subject-inner-wrapper">
//       <div className="superheader">
//         <div className="subjectHeaderdiv">
//           <h5>English Course</h5>
//           <div className="subjectdiv2">
//             <button
//               className="handleNewSubject"
//               onClick={openCreateLevel}
//               disabled={allSlugsUsed}
//               title={allSlugsUsed ? "All three levels already exist" : ""}
//             >
//               + Add New Level
//             </button>
//           </div>
//         </div>

//         {toast && <div className={`ec-toast ec-toast-${toast.type}`}>{toast.text}</div>}

//         <div className="form-sub-container mt-4" id="form">
//           <h4 className="subject-detail">
//             Levels <span className="ec-count">({levels.length}/3)</span>
//           </h4>

//           {levelsError && <div className="ec-alert">{levelsError}</div>}

//           {levelsLoading ? (
//             <div className="ec-empty">Loading levels...</div>
//           ) : levels.length === 0 ? (
//             <div className="ec-empty">
//               No levels yet. Click “Add New Level” to create Beginner, Intermediate or
//               Advanced.
//             </div>
//           ) : (
//             <div className="ec-level-grid">
//               {levels.map((level) => {
//                 const active = selectedLevel?._id === level._id;
//                 return (
//                   <div
//                     key={level._id}
//                     className={`ec-level-card ${active ? "ec-level-active" : ""}`}
//                   >
//                     {level.coverImage ? (
//                       <img
//                         className="ec-cover"
//                         src={level.coverImage}
//                         alt={level.title}
//                         onError={(e) => (e.currentTarget.style.display = "none")}
//                       />
//                     ) : null}

//                     <div className="ec-level-top">
//                       <span className={`ec-slug ec-slug-${level.slug}`}>{level.slug}</span>
//                       <span
//                         className={`ec-badge ${
//                           level.isPublished ? "ec-badge-pub" : "ec-badge-draft"
//                         }`}
//                       >
//                         {level.isPublished ? "Published" : "Draft"}
//                       </span>
//                     </div>

//                     <h4 className="ec-level-title">{level.title}</h4>
//                     <p className="ec-level-desc">
//                       {level.description?.slice(0, 110)}
//                       {level.description?.length > 110 ? "..." : ""}
//                     </p>

//                     <div className="ec-level-meta">
//                       <span className="ec-price">{formatPrice(level.price, level.currency)}</span>
//                       <span>Order: {level.displayOrder}</span>
//                     </div>

//                     <div className="ec-card-actions">
//                       <button
//                         className="ec-btn-primary ec-btn-sm"
//                         onClick={() => setSelectedLevel(active ? null : level)}
//                       >
//                         {active ? "Hide lessons" : "Manage lessons"}
//                       </button>
//                       <button className="ec-btn-secondary ec-btn-sm" onClick={() => openEditLevel(level)}>
//                         Edit
//                       </button>
//                       <button
//                         className="ec-btn-secondary ec-btn-sm"
//                         onClick={() => {
//                           setPriceError("");
//                           setPriceModal({
//                             id: level._id,
//                             title: level.title,
//                             price: level.price,
//                           });
//                         }}
//                       >
//                         Price
//                       </button>
//                       <button
//                         className="ec-btn-secondary ec-btn-sm"
//                         onClick={() => toggleLevelPublish(level)}
//                       >
//                         {level.isPublished ? "Unpublish" : "Publish"}
//                       </button>
//                       <button className="ec-btn-danger ec-btn-sm" onClick={() => deleteLevel(level)}>
//                         Delete
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           )}

//           {/* ---------------- LESSONS ---------------- */}
//           {selectedLevel && (
//             <div className="ec-lessons-section">
//               <div className="ec-lessons-header">
//                 <h4 className="subject-detail">
//                   Lessons — {selectedLevel.title}{" "}
//                   <span className="ec-count">({lessons.length})</span>
//                 </h4>
//                 <button className="handleNewSubject" onClick={openCreateLesson}>
//                   + Add Lesson
//                 </button>
//               </div>

//               {lessonsError && <div className="ec-alert">{lessonsError}</div>}

//               <div className="ec-table-wrap">
//                 <table className="classes-table">
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                       <th>Title</th>
//                       <th>File</th>
//                       <th>Duration</th>
//                       <th>Size</th>
//                       <th>Status</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {lessonsLoading ? (
//                       <tr>
//                         <td colSpan={7} className="ec-empty-row">
//                           Loading lessons...
//                         </td>
//                       </tr>
//                     ) : lessons.length === 0 ? (
//                       <tr>
//                         <td colSpan={7} className="ec-empty-row">
//                           No lessons in this level yet. Add the first one.
//                         </td>
//                       </tr>
//                     ) : (
//                       lessons.map((lesson) => (
//                         <tr key={lesson._id}>
//                           <td>{lesson.lessonNumber}</td>
//                           <td>
//                             <div className="ec-lesson-title">
//                               {lesson.thumbnailUrl && (
//                                 <img
//                                   src={lesson.thumbnailUrl}
//                                   alt=""
//                                   className="ec-thumb"
//                                   onError={(e) => (e.currentTarget.style.display = "none")}
//                                 />
//                               )}
//                               <div>
//                                 <div className="ec-strong">{lesson.title}</div>
//                                 <div className="ec-muted">
//                                   {lesson.description?.slice(0, 60)}
//                                   {lesson.description?.length > 60 ? "..." : ""}
//                                 </div>
//                               </div>
//                             </div>
//                           </td>
//                           <td className="ec-muted">{lesson.originalFileName}</td>
//                           <td>{formatDuration(lesson.durationSeconds)}</td>
//                           <td>{formatSize(lesson.videoSizeBytes)}</td>
//                           <td>
//                             <button
//                               className={`ec-badge ec-badge-btn ${
//                                 lesson.isPublished ? "ec-badge-pub" : "ec-badge-draft"
//                               }`}
//                               onClick={() => toggleLessonPublish(lesson)}
//                               title="Click to toggle"
//                             >
//                               {lesson.isPublished ? "Published" : "Draft"}
//                             </button>
//                           </td>
//                           <td className="table-action-icons">
//                             <i
//                               className="fa-solid fa-file-pen"
//                               title="Edit lesson"
//                               onClick={() => openEditLesson(lesson)}
//                             ></i>
//                             <i
//                               className="fa-solid fa-trash-can"
//                               title="Delete lesson"
//                               onClick={() => deleteLesson(lesson)}
//                             ></i>
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ---------------- LEVEL MODAL ---------------- */}
//       {levelModalOpen && (
//         <div className="ec-overlay" onClick={() => !levelSaving && setLevelModalOpen(false)}>
//           <div className="ec-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="ec-modal-header">
//               <h4>{editingLevelId ? "Edit Level" : "Add New Level"}</h4>
//               <button
//                 className="ec-close"
//                 onClick={() => !levelSaving && setLevelModalOpen(false)}
//                 aria-label="Close"
//               >
//                 <IoClose />
//               </button>
//             </div>

//             <form className="ec-form" onSubmit={submitLevel}>
//               {levelErrors.submit && <div className="ec-alert">{levelErrors.submit}</div>}

//               <div className="ec-grid">
//                 <div className="ec-field">
//                   <label>Level *</label>
//                   <select
//                     name="slug"
//                     value={levelForm.slug}
//                     onChange={handleLevelChange}
//                     disabled={!!editingLevelId}
//                   >
//                     {LEVEL_SLUGS.map((s) => (
//                       <option
//                         key={s}
//                         value={s}
//                         disabled={!editingLevelId && levels.some((l) => l.slug === s)}
//                       >
//                         {s.charAt(0).toUpperCase() + s.slice(1)}
//                         {!editingLevelId && levels.some((l) => l.slug === s) ? " (exists)" : ""}
//                       </option>
//                     ))}
//                   </select>
//                   {levelErrors.slug && <span className="ec-error">{levelErrors.slug}</span>}
//                 </div>

//                 <div className="ec-field">
//                   <label>Display Order</label>
//                   <input
//                     type="number"
//                     name="displayOrder"
//                     min="0"
//                     value={levelForm.displayOrder}
//                     onChange={handleLevelChange}
//                   />
//                   {levelErrors.displayOrder && (
//                     <span className="ec-error">{levelErrors.displayOrder}</span>
//                   )}
//                 </div>

//                 <div className="ec-field ec-full">
//                   <label>Title *</label>
//                   <input
//                     type="text"
//                     name="title"
//                     value={levelForm.title}
//                     onChange={handleLevelChange}
//                     placeholder="e.g. Spoken English — Beginner"
//                   />
//                   {levelErrors.title && <span className="ec-error">{levelErrors.title}</span>}
//                 </div>

//                 <div className="ec-field ec-full">
//                   <label>Description</label>
//                   <textarea
//                     name="description"
//                     rows={3}
//                     value={levelForm.description}
//                     onChange={handleLevelChange}
//                     placeholder="What will students learn in this level?"
//                   />
//                 </div>

//                 {!editingLevelId && (
//                   <div className="ec-field">
//                     <label>Price (INR) *</label>
//                     <input
//                       type="number"
//                       name="price"
//                       min="0"
//                       value={levelForm.price}
//                       onChange={handleLevelChange}
//                       placeholder="e.g. 999"
//                     />
//                     {levelErrors.price && <span className="ec-error">{levelErrors.price}</span>}
//                   </div>
//                 )}

//                 <div className={`ec-field ${editingLevelId ? "ec-full" : ""}`}>
//                   <label>Cover Image URL</label>
//                   <input
//                     type="text"
//                     name="coverImage"
//                     value={levelForm.coverImage}
//                     onChange={handleLevelChange}
//                     placeholder="https://..."
//                   />
//                 </div>

//                 {editingLevelId && (
//                   <div className="ec-hint ec-full">
//                     To change the price use the “Price” button on the level card.
//                   </div>
//                 )}

//                 <div className="ec-field ec-full">
//                   <label className="ec-checkbox">
//                     <input
//                       type="checkbox"
//                       name="isPublished"
//                       checked={levelForm.isPublished}
//                       onChange={handleLevelChange}
//                     />
//                     Publish this level (visible to students)
//                   </label>
//                 </div>
//               </div>

//               <div className="ec-actions">
//                 <button
//                   type="button"
//                   className="ec-btn-secondary"
//                   onClick={() => setLevelModalOpen(false)}
//                   disabled={levelSaving}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" className="ec-btn-primary" disabled={levelSaving}>
//                   {levelSaving ? "Saving..." : editingLevelId ? "Save Changes" : "Create Level"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* ---------------- PRICE MODAL ---------------- */}
//       {priceModal && (
//         <div className="ec-overlay" onClick={() => !priceSaving && setPriceModal(null)}>
//           <div className="ec-modal ec-modal-sm" onClick={(e) => e.stopPropagation()}>
//             <div className="ec-modal-header">
//               <h4>Update Price</h4>
//               <button className="ec-close" onClick={() => setPriceModal(null)} aria-label="Close">
//                 <IoClose />
//               </button>
//             </div>
//             <form className="ec-form" onSubmit={submitPrice}>
//               {priceError && <div className="ec-alert">{priceError}</div>}
//               <div className="ec-field">
//                 <label>Price for “{priceModal.title}” (INR)</label>
//                 <input
//                   type="number"
//                   min="0"
//                   autoFocus
//                   value={priceModal.price}
//                   onChange={(e) => setPriceModal((p) => ({ ...p, price: e.target.value }))}
//                 />
//               </div>
//               <div className="ec-actions">
//                 <button
//                   type="button"
//                   className="ec-btn-secondary"
//                   onClick={() => setPriceModal(null)}
//                   disabled={priceSaving}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" className="ec-btn-primary" disabled={priceSaving}>
//                   {priceSaving ? "Saving..." : "Update Price"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* ---------------- LESSON MODAL ---------------- */}
//       {lessonModalOpen && (
//         <div className="ec-overlay" onClick={() => !lessonSaving && setLessonModalOpen(false)}>
//           <div className="ec-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="ec-modal-header">
//               <h4>
//                 {editingLessonId ? "Edit Lesson" : "Add Lesson"} — {selectedLevel?.title}
//               </h4>
//               <button
//                 className="ec-close"
//                 onClick={() => !lessonSaving && setLessonModalOpen(false)}
//                 aria-label="Close"
//               >
//                 <IoClose />
//               </button>
//             </div>

//             <form className="ec-form" onSubmit={submitLesson}>
//               {lessonErrors.submit && <div className="ec-alert">{lessonErrors.submit}</div>}

//               <div className="ec-grid">
//                 <div className="ec-field">
//                   <label>Lesson Number *</label>
//                   <input
//                     type="number"
//                     name="lessonNumber"
//                     min="1"
//                     value={lessonForm.lessonNumber}
//                     onChange={handleLessonChange}
//                   />
//                   {lessonErrors.lessonNumber && (
//                     <span className="ec-error">{lessonErrors.lessonNumber}</span>
//                   )}
//                 </div>

//                 <div className="ec-field">
//                   <label>Thumbnail URL</label>
//                   <input
//                     type="text"
//                     name="thumbnailUrl"
//                     value={lessonForm.thumbnailUrl}
//                     onChange={handleLessonChange}
//                     placeholder="https://..."
//                   />
//                 </div>

//                 <div className="ec-field ec-full">
//                   <label>Title *</label>
//                   <input
//                     type="text"
//                     name="title"
//                     value={lessonForm.title}
//                     onChange={handleLessonChange}
//                     placeholder="e.g. Introduction to Greetings"
//                   />
//                   {lessonErrors.title && <span className="ec-error">{lessonErrors.title}</span>}
//                 </div>

//                 <div className="ec-field ec-full">
//                   <label>Description</label>
//                   <textarea
//                     name="description"
//                     rows={3}
//                     value={lessonForm.description}
//                     onChange={handleLessonChange}
//                     placeholder="What does this lesson cover?"
//                   />
//                 </div>

//                 <div className="ec-section-title ec-full">Video details</div>

//                 {!editingLessonId && (
//                   <div className="ec-field ec-full">
//                     <label>Private Video Storage Key *</label>
//                     <input
//                       type="text"
//                       name="videoStorageKey"
//                       value={lessonForm.videoStorageKey}
//                       onChange={handleLessonChange}
//                       placeholder="e.g. english-course/beginner/lesson-1.mp4"
//                     />
//                     <span className="ec-hint">
//                       The key of a video already uploaded to private storage. Not a URL or
//                       file path.
//                     </span>
//                     {lessonErrors.videoStorageKey && (
//                       <span className="ec-error">{lessonErrors.videoStorageKey}</span>
//                     )}
//                   </div>
//                 )}

//                 <div className="ec-field ec-full">
//                   <label>Pick video to auto-fill details (optional)</label>
//                   <input type="file" accept="video/*" onChange={handleVideoPick} />
//                   <span className="ec-hint">
//                     Only reads the file name, type, size and duration. The video is not
//                     uploaded from here.
//                   </span>
//                 </div>

//                 <div className="ec-field ec-full">
//                   <label>Original File Name *</label>
//                   <input
//                     type="text"
//                     name="originalFileName"
//                     value={lessonForm.originalFileName}
//                     onChange={handleLessonChange}
//                   />
//                   {lessonErrors.originalFileName && (
//                     <span className="ec-error">{lessonErrors.originalFileName}</span>
//                   )}
//                 </div>

//                 <div className="ec-field">
//                   <label>Video Format *</label>
//                   <select
//                     name="videoMimeType"
//                     value={lessonForm.videoMimeType}
//                     onChange={handleLessonChange}
//                   >
//                     {VIDEO_MIMES.map((m) => (
//                       <option key={m} value={m}>
//                         {m}
//                       </option>
//                     ))}
//                   </select>
//                   {lessonErrors.videoMimeType && (
//                     <span className="ec-error">{lessonErrors.videoMimeType}</span>
//                   )}
//                 </div>

//                 <div className="ec-field">
//                   <label>Size (bytes) *</label>
//                   <input
//                     type="number"
//                     name="videoSizeBytes"
//                     min="1"
//                     value={lessonForm.videoSizeBytes}
//                     onChange={handleLessonChange}
//                   />
//                   {lessonErrors.videoSizeBytes && (
//                     <span className="ec-error">{lessonErrors.videoSizeBytes}</span>
//                   )}
//                 </div>

//                 <div className="ec-field">
//                   <label>Duration (seconds)</label>
//                   <input
//                     type="number"
//                     name="durationSeconds"
//                     min="0"
//                     value={lessonForm.durationSeconds}
//                     onChange={handleLessonChange}
//                   />
//                   {lessonErrors.durationSeconds && (
//                     <span className="ec-error">{lessonErrors.durationSeconds}</span>
//                   )}
//                 </div>

//                 <div className="ec-field ec-checkbox-field">
//                   <label className="ec-checkbox">
//                     <input
//                       type="checkbox"
//                       name="isPublished"
//                       checked={lessonForm.isPublished}
//                       onChange={handleLessonChange}
//                     />
//                     Publish this lesson
//                   </label>
//                 </div>
//               </div>

//               <div className="ec-actions">
//                 <button
//                   type="button"
//                   className="ec-btn-secondary"
//                   onClick={() => setLessonModalOpen(false)}
//                   disabled={lessonSaving}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" className="ec-btn-primary" disabled={lessonSaving}>
//                   {lessonSaving
//                     ? "Saving..."
//                     : editingLessonId
//                     ? "Save Changes"
//                     : "Create Lesson"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EnglishCours;




// import axios from "axios";
// import React, { useCallback, useEffect, useRef, useState } from "react";
// import {
//   IoAdd,
//   IoClose,
//   IoCreateOutline,
//   IoTrashOutline,
//   IoPlayCircleOutline,
//   IoImageOutline,
//   IoVideocamOutline,
// } from "react-icons/io5";
// import "./EnglishCours.css";

// // REACT_APP_API_BASEURL is expected to look like  http://localhost:5001/api
// const API_BASE_URL = process.env.REACT_APP_API_BASEURL || "";
// const BASE = `${API_BASE_URL}/admin/english-course`;
// const SERVER_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, "");

// const VIDEO_TYPES = ["video/mp4", "video/webm", "video/quicktime", "video/x-m4v"];
// const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];
// const MAX_VIDEO = 2 * 1024 * 1024 * 1024; // 2 GB
// const MAX_IMAGE = 5 * 1024 * 1024; // 5 MB

// const EMPTY_LEVEL = {
//   title: "",
//   description: "",
//   price: "",
//   displayOrder: 0,
//   isPublished: false,
// };

// const EMPTY_LESSON = {
//   title: "",
//   description: "",
//   lessonNumber: 1,
//   durationSeconds: 0,
//   isPublished: false,
// };

// // ---------- helpers ----------
// const authHeaders = () => ({
//   headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
// });

// const errMsg = (error, fallback = "Something went wrong. Please try again.") =>
//   error?.response?.data?.message || fallback;

// // Server returns "/api/uploads/..." for stored images; turn it into a full URL.
// const fileUrl = (p) => {
//   if (!p) return "";
//   if (/^https?:\/\//i.test(p)) return p;
//   return `${SERVER_ORIGIN}${p}`;
// };

// const formatPrice = (price, currency = "INR") =>
//   new Intl.NumberFormat("en-IN", {
//     style: "currency",
//     currency,
//     maximumFractionDigits: 0,
//   }).format(price || 0);

// const formatDuration = (sec) => {
//   const s = Math.round(Number(sec) || 0);
//   if (!s) return "—";
//   return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
// };

// const formatSize = (bytes) => {
//   const b = Number(bytes) || 0;
//   if (!b) return "—";
//   if (b < 1024 * 1024) return `${(b / 1024).toFixed(0)} KB`;
//   if (b < 1024 * 1024 * 1024) return `${(b / (1024 * 1024)).toFixed(1)} MB`;
//   return `${(b / (1024 * 1024 * 1024)).toFixed(2)} GB`;
// };

// // Read a video's duration in the browser (nothing is uploaded here).
// const readVideoDuration = (file) =>
//   new Promise((resolve) => {
//     const url = URL.createObjectURL(file);
//     const v = document.createElement("video");
//     v.preload = "metadata";
//     v.onloadedmetadata = () => {
//       URL.revokeObjectURL(url);
//       resolve(Math.round(v.duration || 0));
//     };
//     v.onerror = () => {
//       URL.revokeObjectURL(url);
//       resolve(0);
//     };
//     v.src = url;
//   });

// const EnglishCours = () => {
//   // ---------- shared ----------
//   const [toast, setToast] = useState(null);
//   const toastTimer = useRef(null);

//   const showToast = (type, text) => {
//     setToast({ type, text });
//     clearTimeout(toastTimer.current);
//     toastTimer.current = setTimeout(() => setToast(null), 3500);
//   };

//   useEffect(() => () => clearTimeout(toastTimer.current), []);

//   // ---------- levels ----------
//   const [levels, setLevels] = useState([]);
//   const [levelsLoading, setLevelsLoading] = useState(true);
//   const [levelsError, setLevelsError] = useState("");

//   const [levelModal, setLevelModal] = useState(false);
//   const [editingLevelId, setEditingLevelId] = useState(null);
//   const [levelForm, setLevelForm] = useState(EMPTY_LEVEL);
//   const [levelErrors, setLevelErrors] = useState({});
//   const [levelSaving, setLevelSaving] = useState(false);
//   const [levelProgress, setLevelProgress] = useState(0);

//   // files for the level form
//   const [coverFile, setCoverFile] = useState(null);
//   const [coverPreview, setCoverPreview] = useState("");
//   const [demoFile, setDemoFile] = useState(null);
//   const [demoPreview, setDemoPreview] = useState("");
//   const [existingCover, setExistingCover] = useState("");
//   const [existingDemo, setExistingDemo] = useState(false);
//   const [removeDemo, setRemoveDemo] = useState(false);

//   // demo preview player (admin, works even for drafts)
//   const [demoPlayer, setDemoPlayer] = useState(null); // { title, src, loading }

//   // ---------- lessons ----------
//   const [selectedLevel, setSelectedLevel] = useState(null);
//   const [lessons, setLessons] = useState([]);
//   const [lessonsLoading, setLessonsLoading] = useState(false);
//   const [lessonsError, setLessonsError] = useState("");

//   const [lessonModal, setLessonModal] = useState(false);
//   const [editingLessonId, setEditingLessonId] = useState(null);
//   const [lessonForm, setLessonForm] = useState(EMPTY_LESSON);
//   const [lessonErrors, setLessonErrors] = useState({});
//   const [lessonSaving, setLessonSaving] = useState(false);
//   const [lessonProgress, setLessonProgress] = useState(0);

//   const [videoFile, setVideoFile] = useState(null);
//   const [videoPreview, setVideoPreview] = useState("");
//   const [thumbFile, setThumbFile] = useState(null);
//   const [thumbPreview, setThumbPreview] = useState("");
//   const [existingThumb, setExistingThumb] = useState("");
//   const [existingVideoInfo, setExistingVideoInfo] = useState(null); // { name, size }

//   // ============================================================
//   // object-URL housekeeping (avoid memory leaks)
//   // ============================================================
//   const setPreview = (setter, prevUrl, file) => {
//     if (prevUrl) URL.revokeObjectURL(prevUrl);
//     setter(file ? URL.createObjectURL(file) : "");
//   };

//   const resetLevelFiles = () => {
//     if (coverPreview) URL.revokeObjectURL(coverPreview);
//     if (demoPreview) URL.revokeObjectURL(demoPreview);
//     setCoverFile(null);
//     setCoverPreview("");
//     setDemoFile(null);
//     setDemoPreview("");
//     setExistingCover("");
//     setExistingDemo(false);
//     setRemoveDemo(false);
//   };

//   const resetLessonFiles = () => {
//     if (videoPreview) URL.revokeObjectURL(videoPreview);
//     if (thumbPreview) URL.revokeObjectURL(thumbPreview);
//     setVideoFile(null);
//     setVideoPreview("");
//     setThumbFile(null);
//     setThumbPreview("");
//     setExistingThumb("");
//     setExistingVideoInfo(null);
//   };

//   // ============================================================
//   // FETCH
//   // ============================================================
//   const fetchLevels = useCallback(async () => {
//     try {
//       setLevelsLoading(true);
//       const res = await axios.get(`${BASE}/levels`, authHeaders());
//       const data = res.data?.data || [];
//       setLevels(data);
//       setLevelsError("");
//       setSelectedLevel((prev) =>
//         prev ? data.find((l) => l._id === prev._id) || null : prev
//       );
//     } catch (error) {
//       console.log(error);
//       setLevelsError(errMsg(error, "Couldn't load levels. Please refresh."));
//     } finally {
//       setLevelsLoading(false);
//     }
//   }, []);

//   const fetchLessons = useCallback(async (levelId) => {
//     if (!levelId) return;
//     try {
//       setLessonsLoading(true);
//       const res = await axios.get(`${BASE}/levels/${levelId}/lessons`, authHeaders());
//       setLessons(res.data?.data || []);
//       setLessonsError("");
//     } catch (error) {
//       console.log(error);
//       setLessonsError(errMsg(error, "Couldn't load lessons."));
//     } finally {
//       setLessonsLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchLevels();
//   }, [fetchLevels]);

//   useEffect(() => {
//     if (selectedLevel?._id) fetchLessons(selectedLevel._id);
//     else setLessons([]);
//   }, [selectedLevel?._id, fetchLessons]);

//   // ============================================================
//   // LEVEL ACTIONS
//   // ============================================================
//   const openCreateLevel = () => {
//     resetLevelFiles();
//     setEditingLevelId(null);
//     setLevelForm({ ...EMPTY_LEVEL, displayOrder: levels.length });
//     setLevelErrors({});
//     setLevelProgress(0);
//     setLevelModal(true);
//   };

//   const openEditLevel = (level) => {
//     resetLevelFiles();
//     setEditingLevelId(level._id);
//     setLevelForm({
//       title: level.title || "",
//       description: level.description || "",
//       price: level.price ?? "",
//       displayOrder: level.displayOrder ?? 0,
//       isPublished: !!level.isPublished,
//     });
//     setExistingCover(level.coverImageUrl ? fileUrl(level.coverImageUrl) : "");
//     setExistingDemo(!!level.hasDemoVideo);
//     setLevelErrors({});
//     setLevelProgress(0);
//     setLevelModal(true);
//   };

//   const closeLevelModal = () => {
//     if (levelSaving) return;
//     resetLevelFiles();
//     setLevelModal(false);
//   };

//   const handleLevelChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setLevelForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
//   };

//   const pickCover = (e) => {
//     const file = e.target.files?.[0];
//     e.target.value = "";
//     if (!file) return;
//     if (!IMAGE_TYPES.includes(file.type))
//       return setLevelErrors((p) => ({ ...p, coverImage: "Use a JPG, PNG or WebP image." }));
//     if (file.size > MAX_IMAGE)
//       return setLevelErrors((p) => ({ ...p, coverImage: "Image must be 5 MB or smaller." }));
//     setLevelErrors((p) => ({ ...p, coverImage: undefined }));
//     setCoverFile(file);
//     setPreview(setCoverPreview, coverPreview, file);
//   };

//   const pickDemo = (e) => {
//     const file = e.target.files?.[0];
//     e.target.value = "";
//     if (!file) return;
//     if (!VIDEO_TYPES.includes(file.type))
//       return setLevelErrors((p) => ({ ...p, demoVideo: "Use an MP4, WebM, MOV or M4V video." }));
//     if (file.size > MAX_VIDEO)
//       return setLevelErrors((p) => ({ ...p, demoVideo: "Video must be 2 GB or smaller." }));
//     setLevelErrors((p) => ({ ...p, demoVideo: undefined }));
//     setDemoFile(file);
//     setRemoveDemo(false);
//     setPreview(setDemoPreview, demoPreview, file);
//   };

//   const validateLevel = () => {
//     const e = {};
//     if (!levelForm.title.trim()) e.title = "Level name is required.";
//     else if (levelForm.title.trim().length > 120) e.title = "Max 120 characters.";
//     if (
//       levelForm.price === "" ||
//       !Number.isFinite(Number(levelForm.price)) ||
//       Number(levelForm.price) < 0
//     )
//       e.price = "Enter a valid price (0 or more).";
//     if (
//       levelForm.displayOrder === "" ||
//       !Number.isFinite(Number(levelForm.displayOrder)) ||
//       Number(levelForm.displayOrder) < 0
//     )
//       e.displayOrder = "Must be 0 or more.";
//     setLevelErrors((p) => ({ ...e, coverImage: p.coverImage, demoVideo: p.demoVideo }));
//     return Object.keys(e).length === 0;
//   };

//   const submitLevel = async (ev) => {
//     ev.preventDefault();
//     if (!validateLevel()) return;

//     const fd = new FormData();
//     fd.append("title", levelForm.title.trim());
//     fd.append("description", levelForm.description.trim());
//     fd.append("price", Number(levelForm.price));
//     fd.append("currency", "INR");
//     fd.append("displayOrder", Number(levelForm.displayOrder));
//     fd.append("isPublished", levelForm.isPublished);
//     if (coverFile) fd.append("coverImage", coverFile);
//     if (demoFile) fd.append("demoVideo", demoFile);
//     if (editingLevelId && removeDemo && !demoFile) fd.append("removeDemoVideo", "true");

//     try {
//       setLevelSaving(true);
//       setLevelProgress(0);
//       const config = {
//         ...authHeaders(),
//         onUploadProgress: (p) => {
//           if (p.total) setLevelProgress(Math.round((p.loaded * 100) / p.total));
//         },
//       };
//       if (editingLevelId) {
//         await axios.patch(`${BASE}/levels/${editingLevelId}`, fd, config);
//         showToast("success", "Level updated.");
//       } else {
//         await axios.post(`${BASE}/levels`, fd, config);
//         showToast("success", "Level created.");
//       }
//       resetLevelFiles();
//       setLevelModal(false);
//       fetchLevels();
//     } catch (error) {
//       console.log(error);
//       setLevelErrors((p) => ({ ...p, submit: errMsg(error) }));
//     } finally {
//       setLevelSaving(false);
//     }
//   };

//   const toggleLevelPublish = async (level) => {
//     try {
//       await axios.patch(
//         `${BASE}/levels/${level._id}`,
//         { isPublished: !level.isPublished },
//         authHeaders()
//       );
//       showToast("success", level.isPublished ? "Level unpublished." : "Level published.");
//       fetchLevels();
//     } catch (error) {
//       console.log(error);
//       showToast("error", errMsg(error, "Failed to change publish status."));
//     }
//   };

//   const deleteLevel = async (level) => {
//     if (!window.confirm(`Delete "${level.title}"? This cannot be undone.`)) return;
//     try {
//       const res = await axios.delete(`${BASE}/levels/${level._id}`, authHeaders());
//       showToast("success", res.data?.message || "Level deleted.");
//       if (selectedLevel?._id === level._id) setSelectedLevel(null);
//       fetchLevels();
//     } catch (error) {
//       console.log(error);
//       showToast("error", errMsg(error, "Failed to delete level."));
//     }
//   };

//   // Admin demo preview: fetched with the auth header as a blob, so it also
//   // works for unpublished levels. Demo clips are small, so this is fine.
//   const openDemoPlayer = async (level) => {
//     setDemoPlayer({ title: level.title, src: "", loading: true });
//     try {
//       const res = await axios.get(`${BASE}/levels/${level._id}/demo-video`, {
//         ...authHeaders(),
//         responseType: "blob",
//       });
//       setDemoPlayer({
//         title: level.title,
//         src: URL.createObjectURL(res.data),
//         loading: false,
//       });
//     } catch (error) {
//       console.log(error);
//       setDemoPlayer(null);
//       showToast("error", "Couldn't load the demo video.");
//     }
//   };

//   const closeDemoPlayer = () => {
//     if (demoPlayer?.src) URL.revokeObjectURL(demoPlayer.src);
//     setDemoPlayer(null);
//   };

//   // ============================================================
//   // LESSON ACTIONS
//   // ============================================================
//   const openCreateLesson = () => {
//     resetLessonFiles();
//     const nextNumber = lessons.length
//       ? Math.max(...lessons.map((l) => Number(l.lessonNumber) || 0)) + 1
//       : 1;
//     setEditingLessonId(null);
//     setLessonForm({ ...EMPTY_LESSON, lessonNumber: nextNumber });
//     setLessonErrors({});
//     setLessonProgress(0);
//     setLessonModal(true);
//   };

//   const openEditLesson = (lesson) => {
//     resetLessonFiles();
//     setEditingLessonId(lesson._id);
//     setLessonForm({
//       title: lesson.title || "",
//       description: lesson.description || "",
//       lessonNumber: lesson.lessonNumber ?? 1,
//       durationSeconds: lesson.durationSeconds ?? 0,
//       isPublished: !!lesson.isPublished,
//     });
//     setExistingThumb(lesson.thumbnailUrl ? fileUrl(lesson.thumbnailUrl) : "");
//     setExistingVideoInfo({ name: lesson.originalFileName, size: lesson.videoSizeBytes });
//     setLessonErrors({});
//     setLessonProgress(0);
//     setLessonModal(true);
//   };

//   const closeLessonModal = () => {
//     if (lessonSaving) return;
//     resetLessonFiles();
//     setLessonModal(false);
//   };

//   const handleLessonChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setLessonForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
//   };

//   const pickVideo = async (e) => {
//     const file = e.target.files?.[0];
//     e.target.value = "";
//     if (!file) return;
//     if (!VIDEO_TYPES.includes(file.type))
//       return setLessonErrors((p) => ({ ...p, video: "Use an MP4, WebM, MOV or M4V video." }));
//     if (file.size > MAX_VIDEO)
//       return setLessonErrors((p) => ({ ...p, video: "Video must be 2 GB or smaller." }));
//     setLessonErrors((p) => ({ ...p, video: undefined }));
//     setVideoFile(file);
//     setPreview(setVideoPreview, videoPreview, file);
//     const duration = await readVideoDuration(file);
//     setLessonForm((p) => ({ ...p, durationSeconds: duration }));
//   };

//   const pickThumb = (e) => {
//     const file = e.target.files?.[0];
//     e.target.value = "";
//     if (!file) return;
//     if (!IMAGE_TYPES.includes(file.type))
//       return setLessonErrors((p) => ({ ...p, thumbnail: "Use a JPG, PNG or WebP image." }));
//     if (file.size > MAX_IMAGE)
//       return setLessonErrors((p) => ({ ...p, thumbnail: "Image must be 5 MB or smaller." }));
//     setLessonErrors((p) => ({ ...p, thumbnail: undefined }));
//     setThumbFile(file);
//     setPreview(setThumbPreview, thumbPreview, file);
//   };

//   const validateLesson = () => {
//     const e = {};
//     const f = lessonForm;
//     if (!f.title.trim()) e.title = "Title is required.";
//     else if (f.title.trim().length > 200) e.title = "Max 200 characters.";
//     if (!Number.isInteger(Number(f.lessonNumber)) || Number(f.lessonNumber) < 1)
//       e.lessonNumber = "Must be a positive whole number.";
//     if (!Number.isFinite(Number(f.durationSeconds)) || Number(f.durationSeconds) < 0)
//       e.durationSeconds = "Must be 0 or more.";
//     if (!editingLessonId && !videoFile) e.video = "Please choose a video file.";
//     setLessonErrors((p) => ({ ...e, thumbnail: p.thumbnail, video: e.video || p.video }));
//     return Object.keys(e).length === 0;
//   };

//   const submitLesson = async (ev) => {
//     ev.preventDefault();
//     if (!validateLesson()) return;

//     const f = lessonForm;
//     const fd = new FormData();
//     fd.append("title", f.title.trim());
//     fd.append("description", f.description.trim());
//     fd.append("lessonNumber", Number(f.lessonNumber));
//     fd.append("durationSeconds", Number(f.durationSeconds));
//     fd.append("isPublished", f.isPublished);
//     if (videoFile) fd.append("video", videoFile);
//     if (thumbFile) fd.append("thumbnail", thumbFile);

//     try {
//       setLessonSaving(true);
//       setLessonProgress(0);
//       const config = {
//         ...authHeaders(),
//         onUploadProgress: (p) => {
//           if (p.total) setLessonProgress(Math.round((p.loaded * 100) / p.total));
//         },
//       };
//       if (editingLessonId) {
//         await axios.patch(`${BASE}/lessons/${editingLessonId}`, fd, config);
//         showToast("success", "Lesson updated.");
//       } else {
//         await axios.post(`${BASE}/levels/${selectedLevel._id}/lessons`, fd, config);
//         showToast("success", "Lesson created.");
//       }
//       resetLessonFiles();
//       setLessonModal(false);
//       fetchLessons(selectedLevel._id);
//     } catch (error) {
//       console.log(error);
//       setLessonErrors((p) => ({ ...p, submit: errMsg(error) }));
//     } finally {
//       setLessonSaving(false);
//     }
//   };

//   const toggleLessonPublish = async (lesson) => {
//     try {
//       await axios.patch(
//         `${BASE}/lessons/${lesson._id}`,
//         { isPublished: !lesson.isPublished },
//         authHeaders()
//       );
//       setLessons((prev) =>
//         prev.map((l) => (l._id === lesson._id ? { ...l, isPublished: !l.isPublished } : l))
//       );
//     } catch (error) {
//       console.log(error);
//       showToast("error", errMsg(error, "Failed to change publish status."));
//     }
//   };

//   const deleteLesson = async (lesson) => {
//     if (
//       !window.confirm(
//         `Delete lesson "${lesson.title}"? Its video file and student progress will be removed.`
//       )
//     )
//       return;
//     try {
//       await axios.delete(`${BASE}/lessons/${lesson._id}`, authHeaders());
//       setLessons((prev) => prev.filter((l) => l._id !== lesson._id));
//       showToast("success", "Lesson deleted.");
//     } catch (error) {
//       console.log(error);
//       showToast("error", errMsg(error, "Failed to delete lesson."));
//     }
//   };

//   // ============================================================
//   // RENDER
//   // ============================================================
//   const shownCover = coverPreview || existingCover;
//   const shownThumb = thumbPreview || existingThumb;

//   return (
//     <div id="add-subject-inner-wrapper">
//       <div className="ec-page">
//         {/* ---------- header ---------- */}
//         <header className="ec-header">
//           <div>
//             <h1 className="ec-title">English Course</h1>
//             <p className="ec-subtitle">Create levels, add a demo video, and upload lessons.</p>
//           </div>
//           <button className="ec-btn ec-btn-primary" onClick={openCreateLevel}>
//             <IoAdd size={18} /> New level
//           </button>
//         </header>

//         {toast && <div className={`ec-toast ec-toast-${toast.type}`}>{toast.text}</div>}

//         {/* ---------- levels ---------- */}
//         <section>
//           <div className="ec-section-head">
//             <h2>Levels</h2>
//             <span className="ec-count">{levels.length}</span>
//           </div>

//           {levelsError && <div className="ec-alert">{levelsError}</div>}

//           {levelsLoading ? (
//             <div className="ec-empty">Loading levels…</div>
//           ) : levels.length === 0 ? (
//             <div className="ec-empty">
//               <p>No levels yet.</p>
//               <button className="ec-btn ec-btn-primary" onClick={openCreateLevel}>
//                 <IoAdd size={18} /> Create your first level
//               </button>
//             </div>
//           ) : (
//             <div className="ec-grid-levels">
//               {levels.map((level) => {
//                 const active = selectedLevel?._id === level._id;
//                 const cover = fileUrl(level.coverImageUrl);
//                 return (
//                   <article
//                     key={level._id}
//                     className={`ec-card ${active ? "ec-card-active" : ""}`}
//                   >
//                     <div className="ec-cover-wrap">
//                       {cover ? (
//                         <img
//                           className="ec-cover"
//                           src={cover}
//                           alt={level.title}
//                           onError={(e) => (e.currentTarget.style.display = "none")}
//                         />
//                       ) : (
//                         <div className="ec-cover-empty">
//                           <IoImageOutline size={28} />
//                         </div>
//                       )}
//                       <span
//                         className={`ec-pill ec-pill-float ${
//                           level.isPublished ? "ec-pill-on" : "ec-pill-off"
//                         }`}
//                       >
//                         {level.isPublished ? "Published" : "Draft"}
//                       </span>
//                       {level.hasDemoVideo && (
//                         <button
//                           className="ec-demo-btn"
//                           onClick={() => openDemoPlayer(level)}
//                           title="Play demo video"
//                         >
//                           <IoPlayCircleOutline size={20} /> Demo
//                         </button>
//                       )}
//                     </div>

//                     <div className="ec-card-body">
//                       <h3 className="ec-card-title">{level.title}</h3>
//                       <p className="ec-card-desc">
//                         {level.description
//                           ? level.description.length > 120
//                             ? `${level.description.slice(0, 120)}…`
//                             : level.description
//                           : "No description."}
//                       </p>
//                       <div className="ec-card-meta">
//                         <span className="ec-price">
//                           {formatPrice(level.price, level.currency)}
//                         </span>
//                         <span className="ec-muted">Order {level.displayOrder}</span>
//                       </div>
//                     </div>

//                     <div className="ec-card-actions">
//                       <button
//                         className="ec-btn ec-btn-primary ec-btn-sm"
//                         onClick={() => setSelectedLevel(active ? null : level)}
//                       >
//                         {active ? "Hide lessons" : "Lessons"}
//                       </button>
//                       <button
//                         className="ec-btn ec-btn-ghost ec-btn-sm"
//                         onClick={() => toggleLevelPublish(level)}
//                       >
//                         {level.isPublished ? "Unpublish" : "Publish"}
//                       </button>
//                       <button
//                         className="ec-icon-btn"
//                         onClick={() => openEditLevel(level)}
//                         title="Edit level"
//                         aria-label="Edit level"
//                       >
//                         <IoCreateOutline size={18} />
//                       </button>
//                       <button
//                         className="ec-icon-btn ec-icon-danger"
//                         onClick={() => deleteLevel(level)}
//                         title="Delete level"
//                         aria-label="Delete level"
//                       >
//                         <IoTrashOutline size={18} />
//                       </button>
//                     </div>
//                   </article>
//                 );
//               })}
//             </div>
//           )}
//         </section>

//         {/* ---------- lessons ---------- */}
//         {selectedLevel && (
//           <section className="ec-lessons">
//             <div className="ec-section-head">
//               <h2>
//                 Lessons <span className="ec-muted">· {selectedLevel.title}</span>
//               </h2>
//               <span className="ec-count">{lessons.length}</span>
//               <button className="ec-btn ec-btn-primary ec-btn-sm ec-push" onClick={openCreateLesson}>
//                 <IoAdd size={16} /> Add lesson
//               </button>
//             </div>

//             {lessonsError && <div className="ec-alert">{lessonsError}</div>}

//             <div className="ec-table-wrap">
//               <table className="ec-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: 48 }}>#</th>
//                     <th>Lesson</th>
//                     <th>Duration</th>
//                     <th>Size</th>
//                     <th>Status</th>
//                     <th style={{ width: 96 }}></th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {lessonsLoading ? (
//                     <tr>
//                       <td colSpan={6} className="ec-empty-row">Loading lessons…</td>
//                     </tr>
//                   ) : lessons.length === 0 ? (
//                     <tr>
//                       <td colSpan={6} className="ec-empty-row">
//                         No lessons in this level yet.
//                       </td>
//                     </tr>
//                   ) : (
//                     lessons.map((lesson) => (
//                       <tr key={lesson._id}>
//                         <td className="ec-muted">{lesson.lessonNumber}</td>
//                         <td>
//                           <div className="ec-lesson-cell">
//                             {lesson.thumbnailUrl ? (
//                               <img
//                                 className="ec-thumb"
//                                 src={fileUrl(lesson.thumbnailUrl)}
//                                 alt=""
//                                 onError={(e) => (e.currentTarget.style.display = "none")}
//                               />
//                             ) : (
//                               <div className="ec-thumb ec-thumb-empty">
//                                 <IoVideocamOutline size={18} />
//                               </div>
//                             )}
//                             <div className="ec-lesson-text">
//                               <div className="ec-strong">{lesson.title}</div>
//                               <div className="ec-muted ec-ellipsis">
//                                 {lesson.originalFileName}
//                               </div>
//                             </div>
//                           </div>
//                         </td>
//                         <td>{formatDuration(lesson.durationSeconds)}</td>
//                         <td>{formatSize(lesson.videoSizeBytes)}</td>
//                         <td>
//                           <button
//                             className={`ec-pill ec-pill-btn ${
//                               lesson.isPublished ? "ec-pill-on" : "ec-pill-off"
//                             }`}
//                             onClick={() => toggleLessonPublish(lesson)}
//                             title="Click to toggle"
//                           >
//                             {lesson.isPublished ? "Published" : "Draft"}
//                           </button>
//                         </td>
//                         <td>
//                           <div className="ec-row-actions">
//                             <button
//                               className="ec-icon-btn"
//                               onClick={() => openEditLesson(lesson)}
//                               title="Edit lesson"
//                               aria-label="Edit lesson"
//                             >
//                               <IoCreateOutline size={18} />
//                             </button>
//                             <button
//                               className="ec-icon-btn ec-icon-danger"
//                               onClick={() => deleteLesson(lesson)}
//                               title="Delete lesson"
//                               aria-label="Delete lesson"
//                             >
//                               <IoTrashOutline size={18} />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </section>
//         )}
//       </div>

//       {/* ================= LEVEL MODAL ================= */}
//       {levelModal && (
//         <div className="ec-overlay" onClick={closeLevelModal}>
//           <div className="ec-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="ec-modal-header">
//               <h3>{editingLevelId ? "Edit level" : "New level"}</h3>
//               <button className="ec-icon-btn" onClick={closeLevelModal} aria-label="Close">
//                 <IoClose size={20} />
//               </button>
//             </div>

//             <form className="ec-form" onSubmit={submitLevel}>
//               {levelErrors.submit && <div className="ec-alert">{levelErrors.submit}</div>}

//               <div className="ec-fields">
//                 <div className="ec-field ec-full">
//                   <label>Level name *</label>
//                   <input
//                     type="text"
//                     name="title"
//                     value={levelForm.title}
//                     onChange={handleLevelChange}
//                     placeholder="e.g. Spoken English Foundations"
//                     autoFocus
//                   />
//                   {levelErrors.title && <span className="ec-error">{levelErrors.title}</span>}
//                 </div>

//                 <div className="ec-field ec-full">
//                   <label>Description</label>
//                   <textarea
//                     name="description"
//                     rows={3}
//                     value={levelForm.description}
//                     onChange={handleLevelChange}
//                     placeholder="What will students learn in this level?"
//                   />
//                 </div>

//                 <div className="ec-field">
//                   <label>Price (INR) *</label>
//                   <input
//                     type="number"
//                     name="price"
//                     min="0"
//                     value={levelForm.price}
//                     onChange={handleLevelChange}
//                     placeholder="999"
//                   />
//                   {levelErrors.price && <span className="ec-error">{levelErrors.price}</span>}
//                 </div>

//                 <div className="ec-field">
//                   <label>Display order</label>
//                   <input
//                     type="number"
//                     name="displayOrder"
//                     min="0"
//                     value={levelForm.displayOrder}
//                     onChange={handleLevelChange}
//                   />
//                   {levelErrors.displayOrder && (
//                     <span className="ec-error">{levelErrors.displayOrder}</span>
//                   )}
//                 </div>

//                 {/* cover image */}
//                 <div className="ec-field ec-full">
//                   <label>Cover image</label>
//                   <div className="ec-drop">
//                     {shownCover ? (
//                       <img className="ec-drop-img" src={shownCover} alt="Cover preview" />
//                     ) : (
//                       <div className="ec-drop-empty">
//                         <IoImageOutline size={22} />
//                         <span>JPG, PNG or WebP · up to 5 MB</span>
//                       </div>
//                     )}
//                     <label className="ec-btn ec-btn-ghost ec-btn-sm ec-file-btn">
//                       {shownCover ? "Replace image" : "Choose image"}
//                       <input type="file" accept="image/jpeg,image/png,image/webp" onChange={pickCover} hidden />
//                     </label>
//                   </div>
//                   {levelErrors.coverImage && (
//                     <span className="ec-error">{levelErrors.coverImage}</span>
//                   )}
//                 </div>

//                 {/* demo video */}
//                 <div className="ec-field ec-full">
//                   <label>Demo video <span className="ec-muted">(free preview before enrolling)</span></label>
//                   <div className="ec-drop">
//                     {demoPreview ? (
//                       <video className="ec-drop-video" src={demoPreview} controls preload="metadata" />
//                     ) : existingDemo && !removeDemo ? (
//                       <div className="ec-drop-empty">
//                         <IoVideocamOutline size={22} />
//                         <span>A demo video is already uploaded.</span>
//                       </div>
//                     ) : (
//                       <div className="ec-drop-empty">
//                         <IoVideocamOutline size={22} />
//                         <span>MP4, WebM, MOV or M4V · up to 2 GB · keep it short</span>
//                       </div>
//                     )}
//                     <div className="ec-drop-actions">
//                       <label className="ec-btn ec-btn-ghost ec-btn-sm ec-file-btn">
//                         {demoPreview || (existingDemo && !removeDemo) ? "Replace video" : "Choose video"}
//                         <input
//                           type="file"
//                           accept="video/mp4,video/webm,video/quicktime,video/x-m4v"
//                           onChange={pickDemo}
//                           hidden
//                         />
//                       </label>
//                       {editingLevelId && existingDemo && !demoFile && (
//                         <button
//                           type="button"
//                           className={`ec-btn ec-btn-sm ${removeDemo ? "ec-btn-ghost" : "ec-btn-danger"}`}
//                           onClick={() => setRemoveDemo((v) => !v)}
//                         >
//                           {removeDemo ? "Keep video" : "Remove video"}
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                   {levelErrors.demoVideo && (
//                     <span className="ec-error">{levelErrors.demoVideo}</span>
//                   )}
//                 </div>

//                 <div className="ec-field ec-full">
//                   <label className="ec-check">
//                     <input
//                       type="checkbox"
//                       name="isPublished"
//                       checked={levelForm.isPublished}
//                       onChange={handleLevelChange}
//                     />
//                     Publish this level (visible to students)
//                   </label>
//                 </div>
//               </div>

//               {levelSaving && (
//                 <div className="ec-progress" aria-label="Upload progress">
//                   <div className="ec-progress-bar" style={{ width: `${levelProgress}%` }} />
//                   <span>
//                     {levelProgress < 100 ? `Uploading… ${levelProgress}%` : "Processing…"}
//                   </span>
//                 </div>
//               )}

//               <div className="ec-actions">
//                 <button
//                   type="button"
//                   className="ec-btn ec-btn-ghost"
//                   onClick={closeLevelModal}
//                   disabled={levelSaving}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" className="ec-btn ec-btn-primary" disabled={levelSaving}>
//                   {levelSaving ? "Saving…" : editingLevelId ? "Save changes" : "Create level"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* ================= LESSON MODAL ================= */}
//       {lessonModal && (
//         <div className="ec-overlay" onClick={closeLessonModal}>
//           <div className="ec-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="ec-modal-header">
//               <h3>
//                 {editingLessonId ? "Edit lesson" : "New lesson"}
//                 <span className="ec-muted"> · {selectedLevel?.title}</span>
//               </h3>
//               <button className="ec-icon-btn" onClick={closeLessonModal} aria-label="Close">
//                 <IoClose size={20} />
//               </button>
//             </div>

//             <form className="ec-form" onSubmit={submitLesson}>
//               {lessonErrors.submit && <div className="ec-alert">{lessonErrors.submit}</div>}

//               <div className="ec-fields">
//                 <div className="ec-field ec-full">
//                   <label>Title *</label>
//                   <input
//                     type="text"
//                     name="title"
//                     value={lessonForm.title}
//                     onChange={handleLessonChange}
//                     placeholder="e.g. Greetings and introductions"
//                     autoFocus
//                   />
//                   {lessonErrors.title && <span className="ec-error">{lessonErrors.title}</span>}
//                 </div>

//                 <div className="ec-field ec-full">
//                   <label>Description</label>
//                   <textarea
//                     name="description"
//                     rows={3}
//                     value={lessonForm.description}
//                     onChange={handleLessonChange}
//                     placeholder="What does this lesson cover?"
//                   />
//                 </div>

//                 <div className="ec-field">
//                   <label>Lesson number *</label>
//                   <input
//                     type="number"
//                     name="lessonNumber"
//                     min="1"
//                     value={lessonForm.lessonNumber}
//                     onChange={handleLessonChange}
//                   />
//                   {lessonErrors.lessonNumber && (
//                     <span className="ec-error">{lessonErrors.lessonNumber}</span>
//                   )}
//                 </div>

//                 <div className="ec-field">
//                   <label>Duration (seconds)</label>
//                   <input
//                     type="number"
//                     name="durationSeconds"
//                     min="0"
//                     value={lessonForm.durationSeconds}
//                     onChange={handleLessonChange}
//                   />
//                   <span className="ec-hint">Filled automatically from the video.</span>
//                   {lessonErrors.durationSeconds && (
//                     <span className="ec-error">{lessonErrors.durationSeconds}</span>
//                   )}
//                 </div>

//                 {/* lesson video */}
//                 <div className="ec-field ec-full">
//                   <label>Lesson video {!editingLessonId && "*"}</label>
//                   <div className="ec-drop">
//                     {videoPreview ? (
//                       <video className="ec-drop-video" src={videoPreview} controls preload="metadata" />
//                     ) : (
//                       <div className="ec-drop-empty">
//                         <IoVideocamOutline size={22} />
//                         <span>
//                           {editingLessonId && existingVideoInfo
//                             ? `Current: ${existingVideoInfo.name} (${formatSize(existingVideoInfo.size)})`
//                             : "MP4, WebM, MOV or M4V · up to 2 GB"}
//                         </span>
//                       </div>
//                     )}
//                     <label className="ec-btn ec-btn-ghost ec-btn-sm ec-file-btn">
//                       {videoFile || editingLessonId ? "Replace video" : "Choose video"}
//                       <input
//                         type="file"
//                         accept="video/mp4,video/webm,video/quicktime,video/x-m4v"
//                         onChange={pickVideo}
//                         hidden
//                       />
//                     </label>
//                   </div>
//                   {videoFile && (
//                     <span className="ec-hint">
//                       {videoFile.name} · {formatSize(videoFile.size)}
//                     </span>
//                   )}
//                   {lessonErrors.video && <span className="ec-error">{lessonErrors.video}</span>}
//                 </div>

//                 {/* thumbnail */}
//                 <div className="ec-field ec-full">
//                   <label>Thumbnail</label>
//                   <div className="ec-drop">
//                     {shownThumb ? (
//                       <img className="ec-drop-img ec-drop-img-sm" src={shownThumb} alt="Thumbnail preview" />
//                     ) : (
//                       <div className="ec-drop-empty">
//                         <IoImageOutline size={22} />
//                         <span>JPG, PNG or WebP · up to 5 MB</span>
//                       </div>
//                     )}
//                     <label className="ec-btn ec-btn-ghost ec-btn-sm ec-file-btn">
//                       {shownThumb ? "Replace image" : "Choose image"}
//                       <input type="file" accept="image/jpeg,image/png,image/webp" onChange={pickThumb} hidden />
//                     </label>
//                   </div>
//                   {lessonErrors.thumbnail && (
//                     <span className="ec-error">{lessonErrors.thumbnail}</span>
//                   )}
//                 </div>

//                 <div className="ec-field ec-full">
//                   <label className="ec-check">
//                     <input
//                       type="checkbox"
//                       name="isPublished"
//                       checked={lessonForm.isPublished}
//                       onChange={handleLessonChange}
//                     />
//                     Publish this lesson
//                   </label>
//                 </div>
//               </div>

//               {lessonSaving && (
//                 <div className="ec-progress" aria-label="Upload progress">
//                   <div className="ec-progress-bar" style={{ width: `${lessonProgress}%` }} />
//                   <span>
//                     {lessonProgress < 100 ? `Uploading… ${lessonProgress}%` : "Processing…"}
//                   </span>
//                 </div>
//               )}

//               <div className="ec-actions">
//                 <button
//                   type="button"
//                   className="ec-btn ec-btn-ghost"
//                   onClick={closeLessonModal}
//                   disabled={lessonSaving}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" className="ec-btn ec-btn-primary" disabled={lessonSaving}>
//                   {lessonSaving ? "Uploading…" : editingLessonId ? "Save changes" : "Create lesson"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* ================= DEMO PLAYER ================= */}
//       {demoPlayer && (
//         <div className="ec-overlay" onClick={closeDemoPlayer}>
//           <div className="ec-modal ec-modal-player" onClick={(e) => e.stopPropagation()}>
//             <div className="ec-modal-header">
//               <h3>
//                 Demo <span className="ec-muted">· {demoPlayer.title}</span>
//               </h3>
//               <button className="ec-icon-btn" onClick={closeDemoPlayer} aria-label="Close">
//                 <IoClose size={20} />
//               </button>
//             </div>
//             <div className="ec-player">
//               {demoPlayer.loading ? (
//                 <div className="ec-empty">Loading video…</div>
//               ) : (
//                 <video src={demoPlayer.src} controls autoPlay />
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EnglishCours;










import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  IoAdd,
  IoClose,
  IoCreateOutline,
  IoTrashOutline,
  IoPlayCircleOutline,
  IoImageOutline,
  IoVideocamOutline,
  IoDocumentTextOutline,
  IoEyeOutline,
} from "react-icons/io5";
import "./EnglishCours.css";

// REACT_APP_API_BASEURL is expected to look like  http://localhost:5001/api
const API_BASE_URL = process.env.REACT_APP_API_BASEURL || "";
const BASE = `${API_BASE_URL}/admin/english-course`;
const SERVER_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, "");

const VIDEO_TYPES = ["video/mp4", "video/webm", "video/quicktime", "video/x-m4v"];
const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];
const PDF_TYPES = ["application/pdf"];
const MAX_VIDEO = 2 * 1024 * 1024 * 1024; // 2 GB (server allows up to 5 GB)
const MAX_IMAGE = 5 * 1024 * 1024; // 5 MB
const MAX_PDF = 50 * 1024 * 1024; // 50 MB

const EMPTY_LEVEL = {
  title: "",
  description: "",
  price: "",
  displayOrder: 0,
  isPublished: false,
};

const EMPTY_LESSON = {
  title: "",
  description: "",
  lessonNumber: 1,
  durationSeconds: 0,
  isPublished: false,
};

const EMPTY_PDF = {
  title: "",
  description: "",
  displayOrder: 1,
  isPublished: false,
};

// ---------- helpers ----------
const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

const errMsg = (error, fallback = "Something went wrong. Please try again.") =>
  error?.response?.data?.message || fallback;

// Server returns "/api/uploads/..." for stored images; turn it into a full URL.
const fileUrl = (p) => {
  if (!p) return "";
  if (/^https?:\/\//i.test(p)) return p;
  return `${SERVER_ORIGIN}${p}`;
};

const formatPrice = (price, currency = "INR") =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(price || 0);

const formatDuration = (sec) => {
  const s = Math.round(Number(sec) || 0);
  if (!s) return "—";
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};

const formatSize = (bytes) => {
  const b = Number(bytes) || 0;
  if (!b) return "—";
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(0)} KB`;
  if (b < 1024 * 1024 * 1024) return `${(b / (1024 * 1024)).toFixed(1)} MB`;
  return `${(b / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};

// Read a video's duration in the browser (nothing is uploaded here).
const readVideoDuration = (file) =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const v = document.createElement("video");
    v.preload = "metadata";
    v.onloadedmetadata = () => {
      URL.revokeObjectURL(url);
      resolve(Math.round(v.duration || 0));
    };
    v.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(0);
    };
    v.src = url;
  });

const UploadProgress = ({ value }) => (
  <div className="ec-progress" aria-label="Upload progress">
    <div className="ec-progress-bar" style={{ width: `${value}%` }} />
    <span>{value < 100 ? `Uploading… ${value}%` : "Processing…"}</span>
  </div>
);

const EnglishCours = () => {
  // ---------- shared ----------
  const [toast, setToast] = useState(null);
  const toastTimer = useRef(null);

  const showToast = (type, text) => {
    setToast({ type, text });
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), 3500);
  };

  useEffect(() => () => clearTimeout(toastTimer.current), []);

  // ---------- levels ----------
  const [levels, setLevels] = useState([]);
  const [levelsLoading, setLevelsLoading] = useState(true);
  const [levelsError, setLevelsError] = useState("");

  const [levelModal, setLevelModal] = useState(false);
  const [editingLevelId, setEditingLevelId] = useState(null);
  const [levelForm, setLevelForm] = useState(EMPTY_LEVEL);
  const [levelErrors, setLevelErrors] = useState({});
  const [levelSaving, setLevelSaving] = useState(false);
  const [levelProgress, setLevelProgress] = useState(0);

  const [coverFile, setCoverFile] = useState(null);
  const [coverPreview, setCoverPreview] = useState("");
  const [demoFile, setDemoFile] = useState(null);
  const [demoPreview, setDemoPreview] = useState("");
  const [existingCover, setExistingCover] = useState("");
  const [existingDemo, setExistingDemo] = useState(false);
  const [removeDemo, setRemoveDemo] = useState(false);

  const [demoPlayer, setDemoPlayer] = useState(null); // { title, src, loading }

  // ---------- selected level + tab ----------
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [activeTab, setActiveTab] = useState("videos"); // "videos" | "pdfs"

  // ---------- video lessons ----------
  const [lessons, setLessons] = useState([]);
  const [lessonsLoading, setLessonsLoading] = useState(false);
  const [lessonsError, setLessonsError] = useState("");

  const [lessonModal, setLessonModal] = useState(false);
  const [editingLessonId, setEditingLessonId] = useState(null);
  const [lessonForm, setLessonForm] = useState(EMPTY_LESSON);
  const [lessonErrors, setLessonErrors] = useState({});
  const [lessonSaving, setLessonSaving] = useState(false);
  const [lessonProgress, setLessonProgress] = useState(0);

  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState("");
  const [thumbFile, setThumbFile] = useState(null);
  const [thumbPreview, setThumbPreview] = useState("");
  const [existingThumb, setExistingThumb] = useState("");
  const [existingVideoInfo, setExistingVideoInfo] = useState(null); // { name, size }

  // ---------- PDFs ----------
  const [pdfs, setPdfs] = useState([]);
  const [pdfsLoading, setPdfsLoading] = useState(false);
  const [pdfsError, setPdfsError] = useState("");

  const [pdfModal, setPdfModal] = useState(false);
  const [editingPdfId, setEditingPdfId] = useState(null);
  const [pdfForm, setPdfForm] = useState(EMPTY_PDF);
  const [pdfErrors, setPdfErrors] = useState({});
  const [pdfSaving, setPdfSaving] = useState(false);
  const [pdfProgress, setPdfProgress] = useState(0);

  const [pdfFile, setPdfFile] = useState(null);
  const [existingPdfInfo, setExistingPdfInfo] = useState(null); // { name, size }

  const [pdfViewer, setPdfViewer] = useState(null); // { title, src, loading }

  // ============================================================
  // object-URL housekeeping (avoid memory leaks)
  // ============================================================
  const setPreview = (setter, prevUrl, file) => {
    if (prevUrl) URL.revokeObjectURL(prevUrl);
    setter(file ? URL.createObjectURL(file) : "");
  };

  const resetLevelFiles = () => {
    if (coverPreview) URL.revokeObjectURL(coverPreview);
    if (demoPreview) URL.revokeObjectURL(demoPreview);
    setCoverFile(null);
    setCoverPreview("");
    setDemoFile(null);
    setDemoPreview("");
    setExistingCover("");
    setExistingDemo(false);
    setRemoveDemo(false);
  };

  const resetLessonFiles = () => {
    if (videoPreview) URL.revokeObjectURL(videoPreview);
    if (thumbPreview) URL.revokeObjectURL(thumbPreview);
    setVideoFile(null);
    setVideoPreview("");
    setThumbFile(null);
    setThumbPreview("");
    setExistingThumb("");
    setExistingVideoInfo(null);
  };

  const resetPdfFiles = () => {
    setPdfFile(null);
    setExistingPdfInfo(null);
  };

  // ============================================================
  // FETCH
  // ============================================================
  const fetchLevels = useCallback(async () => {
    try {
      setLevelsLoading(true);
      const res = await axios.get(`${BASE}/levels`, authHeaders());
      const data = res.data?.data || [];
      setLevels(data);
      setLevelsError("");
      setSelectedLevel((prev) =>
        prev ? data.find((l) => l._id === prev._id) || null : prev
      );
    } catch (error) {
      console.log(error);
      setLevelsError(errMsg(error, "Couldn't load levels. Please refresh."));
    } finally {
      setLevelsLoading(false);
    }
  }, []);

  const fetchLessons = useCallback(async (levelId) => {
    if (!levelId) return;
    try {
      setLessonsLoading(true);
      const res = await axios.get(`${BASE}/levels/${levelId}/lessons`, authHeaders());
      setLessons(res.data?.data || []);
      setLessonsError("");
    } catch (error) {
      console.log(error);
      setLessonsError(errMsg(error, "Couldn't load lessons."));
    } finally {
      setLessonsLoading(false);
    }
  }, []);

  const fetchPdfs = useCallback(async (levelId) => {
    if (!levelId) return;
    try {
      setPdfsLoading(true);
      const res = await axios.get(`${BASE}/levels/${levelId}/pdfs`, authHeaders());
      setPdfs(res.data?.data || []);
      setPdfsError("");
    } catch (error) {
      console.log(error);
      setPdfsError(errMsg(error, "Couldn't load PDFs."));
    } finally {
      setPdfsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLevels();
  }, [fetchLevels]);

  useEffect(() => {
    if (selectedLevel?._id) {
      fetchLessons(selectedLevel._id);
      fetchPdfs(selectedLevel._id);
    } else {
      setLessons([]);
      setPdfs([]);
    }
  }, [selectedLevel?._id, fetchLessons, fetchPdfs]);

  const toggleSelectLevel = (level, active) => {
    if (active) {
      setSelectedLevel(null);
    } else {
      setActiveTab("videos");
      setSelectedLevel(level);
    }
  };

  // ============================================================
  // LEVEL ACTIONS
  // ============================================================
  const openCreateLevel = () => {
    resetLevelFiles();
    setEditingLevelId(null);
    setLevelForm({ ...EMPTY_LEVEL, displayOrder: levels.length });
    setLevelErrors({});
    setLevelProgress(0);
    setLevelModal(true);
  };

  const openEditLevel = (level) => {
    resetLevelFiles();
    setEditingLevelId(level._id);
    setLevelForm({
      title: level.title || "",
      description: level.description || "",
      price: level.price ?? "",
      displayOrder: level.displayOrder ?? 0,
      isPublished: !!level.isPublished,
    });
    setExistingCover(level.coverImageUrl ? fileUrl(level.coverImageUrl) : "");
    setExistingDemo(!!level.hasDemoVideo);
    setLevelErrors({});
    setLevelProgress(0);
    setLevelModal(true);
  };

  const closeLevelModal = () => {
    if (levelSaving) return;
    resetLevelFiles();
    setLevelModal(false);
  };

  const handleLevelChange = (e) => {
    const { name, value, type, checked } = e.target;
    setLevelForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
  };

  const pickCover = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!IMAGE_TYPES.includes(file.type))
      return setLevelErrors((p) => ({ ...p, coverImage: "Use a JPG, PNG or WebP image." }));
    if (file.size > MAX_IMAGE)
      return setLevelErrors((p) => ({ ...p, coverImage: "Image must be 5 MB or smaller." }));
    setLevelErrors((p) => ({ ...p, coverImage: undefined }));
    setCoverFile(file);
    setPreview(setCoverPreview, coverPreview, file);
  };

  const pickDemo = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!VIDEO_TYPES.includes(file.type))
      return setLevelErrors((p) => ({ ...p, demoVideo: "Use an MP4, WebM, MOV or M4V video." }));
    if (file.size > MAX_VIDEO)
      return setLevelErrors((p) => ({ ...p, demoVideo: "Video must be 2 GB or smaller." }));
    setLevelErrors((p) => ({ ...p, demoVideo: undefined }));
    setDemoFile(file);
    setRemoveDemo(false);
    setPreview(setDemoPreview, demoPreview, file);
  };

  const validateLevel = () => {
    const e = {};
    if (!levelForm.title.trim()) e.title = "Level name is required.";
    else if (levelForm.title.trim().length > 120) e.title = "Max 120 characters.";
    if (
      levelForm.price === "" ||
      !Number.isFinite(Number(levelForm.price)) ||
      Number(levelForm.price) < 0
    )
      e.price = "Enter a valid price (0 or more).";
    if (
      levelForm.displayOrder === "" ||
      !Number.isFinite(Number(levelForm.displayOrder)) ||
      Number(levelForm.displayOrder) < 0
    )
      e.displayOrder = "Must be 0 or more.";
    setLevelErrors((p) => ({ ...e, coverImage: p.coverImage, demoVideo: p.demoVideo }));
    return Object.keys(e).length === 0;
  };

  const submitLevel = async (ev) => {
    ev.preventDefault();
    if (!validateLevel()) return;

    const fd = new FormData();
    fd.append("title", levelForm.title.trim());
    fd.append("description", levelForm.description.trim());
    fd.append("price", Number(levelForm.price));
    fd.append("currency", "INR");
    fd.append("displayOrder", Number(levelForm.displayOrder));
    fd.append("isPublished", levelForm.isPublished);
    if (coverFile) fd.append("coverImage", coverFile);
    if (demoFile) fd.append("demoVideo", demoFile);
    if (editingLevelId && removeDemo && !demoFile) fd.append("removeDemoVideo", "true");

    try {
      setLevelSaving(true);
      setLevelProgress(0);
      const config = {
        ...authHeaders(),
        onUploadProgress: (p) => {
          if (p.total) setLevelProgress(Math.round((p.loaded * 100) / p.total));
        },
      };
      if (editingLevelId) {
        await axios.patch(`${BASE}/levels/${editingLevelId}`, fd, config);
        showToast("success", "Level updated.");
      } else {
        await axios.post(`${BASE}/levels`, fd, config);
        showToast("success", "Level created.");
      }
      resetLevelFiles();
      setLevelModal(false);
      fetchLevels();
    } catch (error) {
      console.log(error);
      setLevelErrors((p) => ({ ...p, submit: errMsg(error) }));
    } finally {
      setLevelSaving(false);
    }
  };

  const toggleLevelPublish = async (level) => {
    try {
      await axios.patch(
        `${BASE}/levels/${level._id}`,
        { isPublished: !level.isPublished },
        authHeaders()
      );
      showToast("success", level.isPublished ? "Level unpublished." : "Level published.");
      fetchLevels();
    } catch (error) {
      console.log(error);
      showToast("error", errMsg(error, "Failed to change publish status."));
    }
  };

  const deleteLevel = async (level) => {
    if (!window.confirm(`Delete "${level.title}"? This cannot be undone.`)) return;
    try {
      const res = await axios.delete(`${BASE}/levels/${level._id}`, authHeaders());
      showToast("success", res.data?.message || "Level deleted.");
      if (selectedLevel?._id === level._id) setSelectedLevel(null);
      fetchLevels();
    } catch (error) {
      console.log(error);
      showToast("error", errMsg(error, "Failed to delete level."));
    }
  };

  // Admin demo preview: fetched with the auth header as a blob, so it also
  // works for unpublished levels. Demo clips are small, so this is fine.
  const openDemoPlayer = async (level) => {
    setDemoPlayer({ title: level.title, src: "", loading: true });
    try {
      const res = await axios.get(`${BASE}/levels/${level._id}/demo-video`, {
        ...authHeaders(),
        responseType: "blob",
      });
      setDemoPlayer({
        title: level.title,
        src: URL.createObjectURL(res.data),
        loading: false,
      });
    } catch (error) {
      console.log(error);
      setDemoPlayer(null);
      showToast("error", "Couldn't load the demo video.");
    }
  };

  const closeDemoPlayer = () => {
    if (demoPlayer?.src) URL.revokeObjectURL(demoPlayer.src);
    setDemoPlayer(null);
  };

  // ============================================================
  // VIDEO LESSON ACTIONS
  // ============================================================
  const openCreateLesson = () => {
    resetLessonFiles();
    const nextNumber = lessons.length
      ? Math.max(...lessons.map((l) => Number(l.lessonNumber) || 0)) + 1
      : 1;
    setEditingLessonId(null);
    setLessonForm({ ...EMPTY_LESSON, lessonNumber: nextNumber });
    setLessonErrors({});
    setLessonProgress(0);
    setLessonModal(true);
  };

  const openEditLesson = (lesson) => {
    resetLessonFiles();
    setEditingLessonId(lesson._id);
    setLessonForm({
      title: lesson.title || "",
      description: lesson.description || "",
      lessonNumber: lesson.lessonNumber ?? 1,
      durationSeconds: lesson.durationSeconds ?? 0,
      isPublished: !!lesson.isPublished,
    });
    setExistingThumb(lesson.thumbnailUrl ? fileUrl(lesson.thumbnailUrl) : "");
    setExistingVideoInfo({ name: lesson.originalFileName, size: lesson.videoSizeBytes });
    setLessonErrors({});
    setLessonProgress(0);
    setLessonModal(true);
  };

  const closeLessonModal = () => {
    if (lessonSaving) return;
    resetLessonFiles();
    setLessonModal(false);
  };

  const handleLessonChange = (e) => {
    const { name, value, type, checked } = e.target;
    setLessonForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
  };

  const pickVideo = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!VIDEO_TYPES.includes(file.type))
      return setLessonErrors((p) => ({ ...p, video: "Use an MP4, WebM, MOV or M4V video." }));
    if (file.size > MAX_VIDEO)
      return setLessonErrors((p) => ({ ...p, video: "Video must be 2 GB or smaller." }));
    setLessonErrors((p) => ({ ...p, video: undefined }));
    setVideoFile(file);
    setPreview(setVideoPreview, videoPreview, file);
    const duration = await readVideoDuration(file);
    setLessonForm((p) => ({ ...p, durationSeconds: duration }));
  };

  const pickThumb = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!IMAGE_TYPES.includes(file.type))
      return setLessonErrors((p) => ({ ...p, thumbnail: "Use a JPG, PNG or WebP image." }));
    if (file.size > MAX_IMAGE)
      return setLessonErrors((p) => ({ ...p, thumbnail: "Image must be 5 MB or smaller." }));
    setLessonErrors((p) => ({ ...p, thumbnail: undefined }));
    setThumbFile(file);
    setPreview(setThumbPreview, thumbPreview, file);
  };

  const validateLesson = () => {
    const e = {};
    const f = lessonForm;
    if (!f.title.trim()) e.title = "Title is required.";
    else if (f.title.trim().length > 200) e.title = "Max 200 characters.";
    if (!Number.isInteger(Number(f.lessonNumber)) || Number(f.lessonNumber) < 1)
      e.lessonNumber = "Must be a positive whole number.";
    if (!Number.isFinite(Number(f.durationSeconds)) || Number(f.durationSeconds) < 0)
      e.durationSeconds = "Must be 0 or more.";
    if (!editingLessonId && !videoFile) e.video = "Please choose a video file.";
    setLessonErrors((p) => ({ ...e, thumbnail: p.thumbnail, video: e.video || p.video }));
    return Object.keys(e).length === 0;
  };

  const submitLesson = async (ev) => {
    ev.preventDefault();
    if (!validateLesson()) return;

    const f = lessonForm;
    const fd = new FormData();
    fd.append("title", f.title.trim());
    fd.append("description", f.description.trim());
    fd.append("lessonNumber", Number(f.lessonNumber));
    fd.append("durationSeconds", Number(f.durationSeconds));
    fd.append("isPublished", f.isPublished);
    if (videoFile) fd.append("video", videoFile);
    if (thumbFile) fd.append("thumbnail", thumbFile);

    try {
      setLessonSaving(true);
      setLessonProgress(0);
      const config = {
        ...authHeaders(),
        onUploadProgress: (p) => {
          if (p.total) setLessonProgress(Math.round((p.loaded * 100) / p.total));
        },
      };
      if (editingLessonId) {
        await axios.patch(`${BASE}/lessons/${editingLessonId}`, fd, config);
        showToast("success", "Lesson updated.");
      } else {
        await axios.post(`${BASE}/levels/${selectedLevel._id}/lessons`, fd, config);
        showToast("success", "Lesson created.");
      }
      resetLessonFiles();
      setLessonModal(false);
      fetchLessons(selectedLevel._id);
      fetchLevels(); // refresh counts on level cards
    } catch (error) {
      console.log(error);
      setLessonErrors((p) => ({ ...p, submit: errMsg(error) }));
    } finally {
      setLessonSaving(false);
    }
  };

  const toggleLessonPublish = async (lesson) => {
    try {
      await axios.patch(
        `${BASE}/lessons/${lesson._id}`,
        { isPublished: !lesson.isPublished },
        authHeaders()
      );
      setLessons((prev) =>
        prev.map((l) => (l._id === lesson._id ? { ...l, isPublished: !l.isPublished } : l))
      );
    } catch (error) {
      console.log(error);
      showToast("error", errMsg(error, "Failed to change publish status."));
    }
  };

  const deleteLesson = async (lesson) => {
    if (
      !window.confirm(
        `Delete lesson "${lesson.title}"? Its video file and student progress will be removed.`
      )
    )
      return;
    try {
      await axios.delete(`${BASE}/lessons/${lesson._id}`, authHeaders());
      setLessons((prev) => prev.filter((l) => l._id !== lesson._id));
      showToast("success", "Lesson deleted.");
      fetchLevels();
    } catch (error) {
      console.log(error);
      showToast("error", errMsg(error, "Failed to delete lesson."));
    }
  };

  // ============================================================
  // PDF ACTIONS
  // ============================================================
  const openCreatePdf = () => {
    resetPdfFiles();
    const nextOrder = pdfs.length
      ? Math.max(...pdfs.map((p) => Number(p.displayOrder) || 0)) + 1
      : 1;
    setEditingPdfId(null);
    setPdfForm({ ...EMPTY_PDF, displayOrder: nextOrder });
    setPdfErrors({});
    setPdfProgress(0);
    setPdfModal(true);
  };

  const openEditPdf = (pdf) => {
    resetPdfFiles();
    setEditingPdfId(pdf._id);
    setPdfForm({
      title: pdf.title || "",
      description: pdf.description || "",
      displayOrder: pdf.displayOrder ?? 1,
      isPublished: !!pdf.isPublished,
    });
    setExistingPdfInfo({ name: pdf.originalFileName, size: pdf.fileSizeBytes });
    setPdfErrors({});
    setPdfProgress(0);
    setPdfModal(true);
  };

  const closePdfModal = () => {
    if (pdfSaving) return;
    resetPdfFiles();
    setPdfModal(false);
  };

  const handlePdfChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPdfForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
  };

  const pickPdf = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!PDF_TYPES.includes(file.type))
      return setPdfErrors((p) => ({ ...p, pdf: "Only PDF files are allowed." }));
    if (file.size > MAX_PDF)
      return setPdfErrors((p) => ({ ...p, pdf: "PDF must be 50 MB or smaller." }));
    setPdfErrors((p) => ({ ...p, pdf: undefined }));
    setPdfFile(file);
    // Pre-fill the title from the file name if the admin hasn't typed one.
    setPdfForm((p) =>
      p.title.trim() ? p : { ...p, title: file.name.replace(/\.pdf$/i, "").trim() }
    );
  };

  const validatePdf = () => {
    const e = {};
    const f = pdfForm;
    if (!f.title.trim()) e.title = "Title is required.";
    else if (f.title.trim().length > 200) e.title = "Max 200 characters.";
    if (!Number.isInteger(Number(f.displayOrder)) || Number(f.displayOrder) < 1)
      e.displayOrder = "Must be a positive whole number.";
    if (!editingPdfId && !pdfFile) e.pdf = "Please choose a PDF file.";
    setPdfErrors((p) => ({ ...e, pdf: e.pdf || p.pdf }));
    return Object.keys(e).length === 0;
  };

  const submitPdf = async (ev) => {
    ev.preventDefault();
    if (!validatePdf()) return;

    const f = pdfForm;
    const fd = new FormData();
    fd.append("title", f.title.trim());
    fd.append("description", f.description.trim());
    fd.append("displayOrder", Number(f.displayOrder));
    fd.append("isPublished", f.isPublished);
    if (pdfFile) fd.append("pdf", pdfFile);

    try {
      setPdfSaving(true);
      setPdfProgress(0);
      const config = {
        ...authHeaders(),
        onUploadProgress: (p) => {
          if (p.total) setPdfProgress(Math.round((p.loaded * 100) / p.total));
        },
      };
      if (editingPdfId) {
        await axios.patch(`${BASE}/pdfs/${editingPdfId}`, fd, config);
        showToast("success", "PDF updated.");
      } else {
        await axios.post(`${BASE}/levels/${selectedLevel._id}/pdfs`, fd, config);
        showToast("success", "PDF added.");
      }
      resetPdfFiles();
      setPdfModal(false);
      fetchPdfs(selectedLevel._id);
      fetchLevels(); // refresh counts on level cards
    } catch (error) {
      console.log(error);
      setPdfErrors((p) => ({ ...p, submit: errMsg(error) }));
    } finally {
      setPdfSaving(false);
    }
  };

  const togglePdfPublish = async (pdf) => {
    try {
      await axios.patch(
        `${BASE}/pdfs/${pdf._id}`,
        { isPublished: !pdf.isPublished },
        authHeaders()
      );
      setPdfs((prev) =>
        prev.map((p) => (p._id === pdf._id ? { ...p, isPublished: !p.isPublished } : p))
      );
    } catch (error) {
      console.log(error);
      showToast("error", errMsg(error, "Failed to change publish status."));
    }
  };

  const deletePdf = async (pdf) => {
    if (!window.confirm(`Delete PDF "${pdf.title}"? The file will be removed.`)) return;
    try {
      await axios.delete(`${BASE}/pdfs/${pdf._id}`, authHeaders());
      setPdfs((prev) => prev.filter((p) => p._id !== pdf._id));
      showToast("success", "PDF deleted.");
      fetchLevels();
    } catch (error) {
      console.log(error);
      showToast("error", errMsg(error, "Failed to delete PDF."));
    }
  };

  // Admin PDF preview: fetched with the auth header as a blob (works for drafts too).
  const openPdfViewer = async (pdf) => {
    setPdfViewer({ title: pdf.title, src: "", loading: true });
    try {
      const res = await axios.get(`${BASE}/pdfs/${pdf._id}/file`, {
        ...authHeaders(),
        responseType: "blob",
      });
      const blob = new Blob([res.data], { type: "application/pdf" });
      setPdfViewer({ title: pdf.title, src: URL.createObjectURL(blob), loading: false });
    } catch (error) {
      console.log(error);
      setPdfViewer(null);
      showToast("error", "Couldn't load the PDF.");
    }
  };

  const closePdfViewer = () => {
    if (pdfViewer?.src) URL.revokeObjectURL(pdfViewer.src);
    setPdfViewer(null);
  };

  // ============================================================
  // RENDER
  // ============================================================
  const shownCover = coverPreview || existingCover;
  const shownThumb = thumbPreview || existingThumb;

  return (
    <div id="add-subject-inner-wrapper">
      <div className="ec-page">
        {/* ---------- header ---------- */}
        <header className="ec-header">
          <div>
            <h1 className="ec-title">English Course</h1>
            <p className="ec-subtitle">
              Create levels, add a demo video, then upload video lessons and PDF notes.
            </p>
          </div>
          <button className="ec-btn ec-btn-primary" onClick={openCreateLevel}>
            <IoAdd size={18} /> New level
          </button>
        </header>

        {toast && <div className={`ec-toast ec-toast-${toast.type}`}>{toast.text}</div>}

        {/* ---------- levels ---------- */}
        <section>
          <div className="ec-section-head">
            <h2>Levels</h2>
            <span className="ec-count">{levels.length}</span>
          </div>

          {levelsError && <div className="ec-alert">{levelsError}</div>}

          {levelsLoading && levels.length === 0 ? (
            <div className="ec-empty">Loading levels…</div>
          ) : levels.length === 0 ? (
            <div className="ec-empty">
              <p>No levels yet.</p>
              <button className="ec-btn ec-btn-primary" onClick={openCreateLevel}>
                <IoAdd size={18} /> Create your first level
              </button>
            </div>
          ) : (
            <div className="ec-grid-levels">
              {levels.map((level) => {
                const active = selectedLevel?._id === level._id;
                const cover = fileUrl(level.coverImageUrl);
                return (
                  <article
                    key={level._id}
                    className={`ec-card ${active ? "ec-card-active" : ""}`}
                  >
                    <div className="ec-cover-wrap">
                      {cover ? (
                        <img
                          className="ec-cover"
                          src={cover}
                          alt={level.title}
                          onError={(e) => (e.currentTarget.style.display = "none")}
                        />
                      ) : (
                        <div className="ec-cover-empty">
                          <IoImageOutline size={28} />
                        </div>
                      )}
                      <span
                        className={`ec-pill ec-pill-float ${
                          level.isPublished ? "ec-pill-on" : "ec-pill-off"
                        }`}
                      >
                        {level.isPublished ? "Published" : "Draft"}
                      </span>
                      {level.hasDemoVideo && (
                        <button
                          className="ec-demo-btn"
                          onClick={() => openDemoPlayer(level)}
                          title="Play demo video"
                        >
                          <IoPlayCircleOutline size={20} /> Demo
                        </button>
                      )}
                    </div>

                    <div className="ec-card-body">
                      <h3 className="ec-card-title">{level.title}</h3>
                      <p className="ec-card-desc">
                        {level.description
                          ? level.description.length > 120
                            ? `${level.description.slice(0, 120)}…`
                            : level.description
                          : "No description."}
                      </p>
                      <div className="ec-card-stats">
                        <span>
                          <IoVideocamOutline size={14} /> {level.totalLessonCount ?? 0} videos
                        </span>
                        <span>
                          <IoDocumentTextOutline size={14} /> {level.totalPdfCount ?? 0} PDFs
                        </span>
                      </div>
                      <div className="ec-card-meta">
                        <span className="ec-price">
                          {formatPrice(level.price, level.currency)}
                        </span>
                        <span className="ec-muted">Order {level.displayOrder}</span>
                      </div>
                    </div>

                    <div className="ec-card-actions">
                      <button
                        className="ec-btn ec-btn-primary ec-btn-sm"
                        onClick={() => toggleSelectLevel(level, active)}
                      >
                        {active ? "Hide content" : "Content"}
                      </button>
                      <button
                        className="ec-btn ec-btn-ghost ec-btn-sm"
                        onClick={() => toggleLevelPublish(level)}
                      >
                        {level.isPublished ? "Unpublish" : "Publish"}
                      </button>
                      <button
                        className="ec-icon-btn ec-push"
                        onClick={() => openEditLevel(level)}
                        title="Edit level"
                        aria-label="Edit level"
                      >
                        <IoCreateOutline size={18} />
                      </button>
                      <button
                        className="ec-icon-btn ec-icon-danger"
                        onClick={() => deleteLevel(level)}
                        title="Delete level"
                        aria-label="Delete level"
                      >
                        <IoTrashOutline size={18} />
                      </button>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </section>

        {/* ---------- content (videos + PDFs) ---------- */}
        {selectedLevel && (
          <section className="ec-lessons">
            <div className="ec-section-head">
              <h2>
                Content <span className="ec-muted">· {selectedLevel.title}</span>
              </h2>
              {activeTab === "videos" ? (
                <button
                  className="ec-btn ec-btn-primary ec-btn-sm ec-push"
                  onClick={openCreateLesson}
                >
                  <IoAdd size={16} /> Add video lesson
                </button>
              ) : (
                <button
                  className="ec-btn ec-btn-primary ec-btn-sm ec-push"
                  onClick={openCreatePdf}
                >
                  <IoAdd size={16} /> Add PDF
                </button>
              )}
            </div>

            <div className="ec-tabs" role="tablist">
              <button
                role="tab"
                aria-selected={activeTab === "videos"}
                className={`ec-tab ${activeTab === "videos" ? "ec-tab-active" : ""}`}
                onClick={() => setActiveTab("videos")}
              >
                <IoVideocamOutline size={16} /> Video lessons
                <span className="ec-tab-count">{lessons.length}</span>
              </button>
              <button
                role="tab"
                aria-selected={activeTab === "pdfs"}
                className={`ec-tab ${activeTab === "pdfs" ? "ec-tab-active" : ""}`}
                onClick={() => setActiveTab("pdfs")}
              >
                <IoDocumentTextOutline size={16} /> PDFs
                <span className="ec-tab-count">{pdfs.length}</span>
              </button>
            </div>

            {/* ----- VIDEO LESSONS TABLE ----- */}
            {activeTab === "videos" && (
              <>
                {lessonsError && <div className="ec-alert">{lessonsError}</div>}
                <div className="ec-table-wrap">
                  <table className="ec-table">
                    <thead>
                      <tr>
                        <th style={{ width: 48 }}>#</th>
                        <th>Lesson</th>
                        <th>Duration</th>
                        <th>Size</th>
                        <th>Status</th>
                        <th style={{ width: 96 }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {lessonsLoading ? (
                        <tr>
                          <td colSpan={6} className="ec-empty-row">Loading lessons…</td>
                        </tr>
                      ) : lessons.length === 0 ? (
                        <tr>
                          <td colSpan={6} className="ec-empty-row">
                            No video lessons in this level yet.
                          </td>
                        </tr>
                      ) : (
                        lessons.map((lesson) => (
                          <tr key={lesson._id}>
                            <td className="ec-muted">{lesson.lessonNumber}</td>
                            <td>
                              <div className="ec-lesson-cell">
                                {lesson.thumbnailUrl ? (
                                  <img
                                    className="ec-thumb"
                                    src={fileUrl(lesson.thumbnailUrl)}
                                    alt=""
                                    onError={(e) => (e.currentTarget.style.display = "none")}
                                  />
                                ) : (
                                  <div className="ec-thumb ec-thumb-empty">
                                    <IoVideocamOutline size={18} />
                                  </div>
                                )}
                                <div className="ec-lesson-text">
                                  <div className="ec-strong">{lesson.title}</div>
                                  <div className="ec-muted ec-ellipsis">
                                    {lesson.originalFileName}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>{formatDuration(lesson.durationSeconds)}</td>
                            <td>{formatSize(lesson.videoSizeBytes)}</td>
                            <td>
                              <button
                                className={`ec-pill ec-pill-btn ${
                                  lesson.isPublished ? "ec-pill-on" : "ec-pill-off"
                                }`}
                                onClick={() => toggleLessonPublish(lesson)}
                                title="Click to toggle"
                              >
                                {lesson.isPublished ? "Published" : "Draft"}
                              </button>
                            </td>
                            <td>
                              <div className="ec-row-actions">
                                <button
                                  className="ec-icon-btn"
                                  onClick={() => openEditLesson(lesson)}
                                  title="Edit lesson"
                                  aria-label="Edit lesson"
                                >
                                  <IoCreateOutline size={18} />
                                </button>
                                <button
                                  className="ec-icon-btn ec-icon-danger"
                                  onClick={() => deleteLesson(lesson)}
                                  title="Delete lesson"
                                  aria-label="Delete lesson"
                                >
                                  <IoTrashOutline size={18} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* ----- PDFS TABLE ----- */}
            {activeTab === "pdfs" && (
              <>
                {pdfsError && <div className="ec-alert">{pdfsError}</div>}
                <div className="ec-table-wrap">
                  <table className="ec-table">
                    <thead>
                      <tr>
                        <th style={{ width: 48 }}>#</th>
                        <th>Document</th>
                        <th>Size</th>
                        <th>Status</th>
                        <th style={{ width: 132 }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {pdfsLoading ? (
                        <tr>
                          <td colSpan={5} className="ec-empty-row">Loading PDFs…</td>
                        </tr>
                      ) : pdfs.length === 0 ? (
                        <tr>
                          <td colSpan={5} className="ec-empty-row">
                            No PDFs in this level yet.
                          </td>
                        </tr>
                      ) : (
                        pdfs.map((pdf) => (
                          <tr key={pdf._id}>
                            <td className="ec-muted">{pdf.displayOrder}</td>
                            <td>
                              <div className="ec-lesson-cell">
                                <div className="ec-thumb ec-thumb-empty ec-thumb-pdf">
                                  <IoDocumentTextOutline size={20} />
                                </div>
                                <div className="ec-lesson-text">
                                  <div className="ec-strong">{pdf.title}</div>
                                  <div className="ec-muted ec-ellipsis">
                                    {pdf.originalFileName}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>{formatSize(pdf.fileSizeBytes)}</td>
                            <td>
                              <button
                                className={`ec-pill ec-pill-btn ${
                                  pdf.isPublished ? "ec-pill-on" : "ec-pill-off"
                                }`}
                                onClick={() => togglePdfPublish(pdf)}
                                title="Click to toggle"
                              >
                                {pdf.isPublished ? "Published" : "Draft"}
                              </button>
                            </td>
                            <td>
                              <div className="ec-row-actions">
                                <button
                                  className="ec-icon-btn"
                                  onClick={() => openPdfViewer(pdf)}
                                  title="View PDF"
                                  aria-label="View PDF"
                                >
                                  <IoEyeOutline size={18} />
                                </button>
                                <button
                                  className="ec-icon-btn"
                                  onClick={() => openEditPdf(pdf)}
                                  title="Edit PDF"
                                  aria-label="Edit PDF"
                                >
                                  <IoCreateOutline size={18} />
                                </button>
                                <button
                                  className="ec-icon-btn ec-icon-danger"
                                  onClick={() => deletePdf(pdf)}
                                  title="Delete PDF"
                                  aria-label="Delete PDF"
                                >
                                  <IoTrashOutline size={18} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </section>
        )}
      </div>

      {/* ================= LEVEL MODAL ================= */}
      {levelModal && (
        <div className="ec-overlay" onClick={closeLevelModal}>
          <div className="ec-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ec-modal-header">
              <h3>{editingLevelId ? "Edit level" : "New level"}</h3>
              <button className="ec-icon-btn" onClick={closeLevelModal} aria-label="Close">
                <IoClose size={20} />
              </button>
            </div>

            <form className="ec-form" onSubmit={submitLevel}>
              {levelErrors.submit && <div className="ec-alert">{levelErrors.submit}</div>}

              <div className="ec-fields">
                <div className="ec-field ec-full">
                  <label>Level name *</label>
                  <input
                    type="text"
                    name="title"
                    value={levelForm.title}
                    onChange={handleLevelChange}
                    placeholder="e.g. Spoken English Foundations"
                    autoFocus
                  />
                  {levelErrors.title && <span className="ec-error">{levelErrors.title}</span>}
                </div>

                <div className="ec-field ec-full">
                  <label>Description</label>
                  <textarea
                    name="description"
                    rows={3}
                    value={levelForm.description}
                    onChange={handleLevelChange}
                    placeholder="What will students learn in this level?"
                  />
                </div>

                <div className="ec-field">
                  <label>Price (INR) *</label>
                  <input
                    type="number"
                    name="price"
                    min="0"
                    value={levelForm.price}
                    onChange={handleLevelChange}
                    placeholder="999"
                  />
                  {levelErrors.price && <span className="ec-error">{levelErrors.price}</span>}
                </div>

                <div className="ec-field">
                  <label>Display order</label>
                  <input
                    type="number"
                    name="displayOrder"
                    min="0"
                    value={levelForm.displayOrder}
                    onChange={handleLevelChange}
                  />
                  {levelErrors.displayOrder && (
                    <span className="ec-error">{levelErrors.displayOrder}</span>
                  )}
                </div>

                {/* cover image */}
                <div className="ec-field ec-full">
                  <label>Cover image</label>
                  <div className="ec-drop">
                    {shownCover ? (
                      <img className="ec-drop-img" src={shownCover} alt="Cover preview" />
                    ) : (
                      <div className="ec-drop-empty">
                        <IoImageOutline size={22} />
                        <span>JPG, PNG or WebP · up to 5 MB</span>
                      </div>
                    )}
                    <label className="ec-btn ec-btn-ghost ec-btn-sm ec-file-btn">
                      {shownCover ? "Replace image" : "Choose image"}
                      <input
                        type="file"
                        accept="image/jpeg,image/png,image/webp"
                        onChange={pickCover}
                        hidden
                      />
                    </label>
                  </div>
                  {levelErrors.coverImage && (
                    <span className="ec-error">{levelErrors.coverImage}</span>
                  )}
                </div>

                {/* demo video */}
                <div className="ec-field ec-full">
                  <label>
                    Demo video <span className="ec-muted">(free preview before enrolling)</span>
                  </label>
                  <div className="ec-drop">
                    {demoPreview ? (
                      <video className="ec-drop-video" src={demoPreview} controls preload="metadata" />
                    ) : existingDemo && !removeDemo ? (
                      <div className="ec-drop-empty">
                        <IoVideocamOutline size={22} />
                        <span>A demo video is already uploaded.</span>
                      </div>
                    ) : (
                      <div className="ec-drop-empty">
                        <IoVideocamOutline size={22} />
                        <span>MP4, WebM, MOV or M4V · up to 2 GB · keep it short</span>
                      </div>
                    )}
                    <div className="ec-drop-actions">
                      <label className="ec-btn ec-btn-ghost ec-btn-sm ec-file-btn">
                        {demoPreview || (existingDemo && !removeDemo)
                          ? "Replace video"
                          : "Choose video"}
                        <input
                          type="file"
                          accept="video/mp4,video/webm,video/quicktime,video/x-m4v"
                          onChange={pickDemo}
                          hidden
                        />
                      </label>
                      {editingLevelId && existingDemo && !demoFile && (
                        <button
                          type="button"
                          className={`ec-btn ec-btn-sm ${
                            removeDemo ? "ec-btn-ghost" : "ec-btn-danger"
                          }`}
                          onClick={() => setRemoveDemo((v) => !v)}
                        >
                          {removeDemo ? "Keep video" : "Remove video"}
                        </button>
                      )}
                    </div>
                  </div>
                  {levelErrors.demoVideo && (
                    <span className="ec-error">{levelErrors.demoVideo}</span>
                  )}
                </div>

                <div className="ec-field ec-full">
                  <label className="ec-check">
                    <input
                      type="checkbox"
                      name="isPublished"
                      checked={levelForm.isPublished}
                      onChange={handleLevelChange}
                    />
                    Publish this level (visible to students)
                  </label>
                </div>
              </div>

              {levelSaving && <UploadProgress value={levelProgress} />}

              <div className="ec-actions">
                <button
                  type="button"
                  className="ec-btn ec-btn-ghost"
                  onClick={closeLevelModal}
                  disabled={levelSaving}
                >
                  Cancel
                </button>
                <button type="submit" className="ec-btn ec-btn-primary" disabled={levelSaving}>
                  {levelSaving ? "Saving…" : editingLevelId ? "Save changes" : "Create level"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ================= LESSON MODAL ================= */}
      {lessonModal && (
        <div className="ec-overlay" onClick={closeLessonModal}>
          <div className="ec-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ec-modal-header">
              <h3>
                {editingLessonId ? "Edit video lesson" : "New video lesson"}
                <span className="ec-muted"> · {selectedLevel?.title}</span>
              </h3>
              <button className="ec-icon-btn" onClick={closeLessonModal} aria-label="Close">
                <IoClose size={20} />
              </button>
            </div>

            <form className="ec-form" onSubmit={submitLesson}>
              {lessonErrors.submit && <div className="ec-alert">{lessonErrors.submit}</div>}

              <div className="ec-fields">
                <div className="ec-field ec-full">
                  <label>Title *</label>
                  <input
                    type="text"
                    name="title"
                    value={lessonForm.title}
                    onChange={handleLessonChange}
                    placeholder="e.g. Greetings and introductions"
                    autoFocus
                  />
                  {lessonErrors.title && <span className="ec-error">{lessonErrors.title}</span>}
                </div>

                <div className="ec-field ec-full">
                  <label>Description</label>
                  <textarea
                    name="description"
                    rows={3}
                    value={lessonForm.description}
                    onChange={handleLessonChange}
                    placeholder="What does this lesson cover?"
                  />
                </div>

                <div className="ec-field">
                  <label>Lesson number *</label>
                  <input
                    type="number"
                    name="lessonNumber"
                    min="1"
                    value={lessonForm.lessonNumber}
                    onChange={handleLessonChange}
                  />
                  {lessonErrors.lessonNumber && (
                    <span className="ec-error">{lessonErrors.lessonNumber}</span>
                  )}
                </div>

                <div className="ec-field">
                  <label>Duration (seconds)</label>
                  <input
                    type="number"
                    name="durationSeconds"
                    min="0"
                    value={lessonForm.durationSeconds}
                    onChange={handleLessonChange}
                  />
                  <span className="ec-hint">Filled automatically from the video.</span>
                  {lessonErrors.durationSeconds && (
                    <span className="ec-error">{lessonErrors.durationSeconds}</span>
                  )}
                </div>

                {/* lesson video */}
                <div className="ec-field ec-full">
                  <label>Lesson video {!editingLessonId && "*"}</label>
                  <div className="ec-drop">
                    {videoPreview ? (
                      <video className="ec-drop-video" src={videoPreview} controls preload="metadata" />
                    ) : (
                      <div className="ec-drop-empty">
                        <IoVideocamOutline size={22} />
                        <span>
                          {editingLessonId && existingVideoInfo
                            ? `Current: ${existingVideoInfo.name} (${formatSize(existingVideoInfo.size)})`
                            : "MP4, WebM, MOV or M4V · up to 2 GB"}
                        </span>
                      </div>
                    )}
                    <label className="ec-btn ec-btn-ghost ec-btn-sm ec-file-btn">
                      {videoFile || editingLessonId ? "Replace video" : "Choose video"}
                      <input
                        type="file"
                        accept="video/mp4,video/webm,video/quicktime,video/x-m4v"
                        onChange={pickVideo}
                        hidden
                      />
                    </label>
                  </div>
                  {videoFile && (
                    <span className="ec-hint">
                      {videoFile.name} · {formatSize(videoFile.size)}
                    </span>
                  )}
                  {lessonErrors.video && <span className="ec-error">{lessonErrors.video}</span>}
                </div>

                {/* thumbnail */}
                <div className="ec-field ec-full">
                  <label>Thumbnail</label>
                  <div className="ec-drop">
                    {shownThumb ? (
                      <img
                        className="ec-drop-img ec-drop-img-sm"
                        src={shownThumb}
                        alt="Thumbnail preview"
                      />
                    ) : (
                      <div className="ec-drop-empty">
                        <IoImageOutline size={22} />
                        <span>JPG, PNG or WebP · up to 5 MB</span>
                      </div>
                    )}
                    <label className="ec-btn ec-btn-ghost ec-btn-sm ec-file-btn">
                      {shownThumb ? "Replace image" : "Choose image"}
                      <input
                        type="file"
                        accept="image/jpeg,image/png,image/webp"
                        onChange={pickThumb}
                        hidden
                      />
                    </label>
                  </div>
                  {lessonErrors.thumbnail && (
                    <span className="ec-error">{lessonErrors.thumbnail}</span>
                  )}
                </div>

                <div className="ec-field ec-full">
                  <label className="ec-check">
                    <input
                      type="checkbox"
                      name="isPublished"
                      checked={lessonForm.isPublished}
                      onChange={handleLessonChange}
                    />
                    Publish this lesson
                  </label>
                </div>
              </div>

              {lessonSaving && <UploadProgress value={lessonProgress} />}

              <div className="ec-actions">
                <button
                  type="button"
                  className="ec-btn ec-btn-ghost"
                  onClick={closeLessonModal}
                  disabled={lessonSaving}
                >
                  Cancel
                </button>
                <button type="submit" className="ec-btn ec-btn-primary" disabled={lessonSaving}>
                  {lessonSaving ? "Uploading…" : editingLessonId ? "Save changes" : "Create lesson"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ================= PDF MODAL ================= */}
      {pdfModal && (
        <div className="ec-overlay" onClick={closePdfModal}>
          <div className="ec-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ec-modal-header">
              <h3>
                {editingPdfId ? "Edit PDF" : "New PDF"}
                <span className="ec-muted"> · {selectedLevel?.title}</span>
              </h3>
              <button className="ec-icon-btn" onClick={closePdfModal} aria-label="Close">
                <IoClose size={20} />
              </button>
            </div>

            <form className="ec-form" onSubmit={submitPdf}>
              {pdfErrors.submit && <div className="ec-alert">{pdfErrors.submit}</div>}

              <div className="ec-fields">
                <div className="ec-field ec-full">
                  <label>Title *</label>
                  <input
                    type="text"
                    name="title"
                    value={pdfForm.title}
                    onChange={handlePdfChange}
                    placeholder="e.g. Grammar workbook — Unit 1"
                    autoFocus
                  />
                  {pdfErrors.title && <span className="ec-error">{pdfErrors.title}</span>}
                </div>

                <div className="ec-field ec-full">
                  <label>Description</label>
                  <textarea
                    name="description"
                    rows={3}
                    value={pdfForm.description}
                    onChange={handlePdfChange}
                    placeholder="What is in this document?"
                  />
                </div>

                <div className="ec-field ec-full">
                  <label>Display order *</label>
                  <input
                    type="number"
                    name="displayOrder"
                    min="1"
                    value={pdfForm.displayOrder}
                    onChange={handlePdfChange}
                  />
                  <span className="ec-hint">Each PDF in a level needs a unique number.</span>
                  {pdfErrors.displayOrder && (
                    <span className="ec-error">{pdfErrors.displayOrder}</span>
                  )}
                </div>

                {/* pdf file */}
                <div className="ec-field ec-full">
                  <label>PDF file {!editingPdfId && "*"}</label>
                  <div className="ec-drop">
                    <div className="ec-drop-empty">
                      <IoDocumentTextOutline size={22} />
                      <span>
                        {pdfFile
                          ? `${pdfFile.name} (${formatSize(pdfFile.size)})`
                          : editingPdfId && existingPdfInfo
                          ? `Current: ${existingPdfInfo.name} (${formatSize(existingPdfInfo.size)})`
                          : "PDF only · up to 50 MB"}
                      </span>
                    </div>
                    <label className="ec-btn ec-btn-ghost ec-btn-sm ec-file-btn">
                      {pdfFile || editingPdfId ? "Replace PDF" : "Choose PDF"}
                      <input type="file" accept="application/pdf" onChange={pickPdf} hidden />
                    </label>
                  </div>
                  {pdfErrors.pdf && <span className="ec-error">{pdfErrors.pdf}</span>}
                </div>

                <div className="ec-field ec-full">
                  <label className="ec-check">
                    <input
                      type="checkbox"
                      name="isPublished"
                      checked={pdfForm.isPublished}
                      onChange={handlePdfChange}
                    />
                    Publish this PDF
                  </label>
                </div>
              </div>

              {pdfSaving && <UploadProgress value={pdfProgress} />}

              <div className="ec-actions">
                <button
                  type="button"
                  className="ec-btn ec-btn-ghost"
                  onClick={closePdfModal}
                  disabled={pdfSaving}
                >
                  Cancel
                </button>
                <button type="submit" className="ec-btn ec-btn-primary" disabled={pdfSaving}>
                  {pdfSaving ? "Uploading…" : editingPdfId ? "Save changes" : "Add PDF"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ================= DEMO PLAYER ================= */}
      {demoPlayer && (
        <div className="ec-overlay" onClick={closeDemoPlayer}>
          <div className="ec-modal ec-modal-player" onClick={(e) => e.stopPropagation()}>
            <div className="ec-modal-header">
              <h3>
                Demo <span className="ec-muted">· {demoPlayer.title}</span>
              </h3>
              <button className="ec-icon-btn" onClick={closeDemoPlayer} aria-label="Close">
                <IoClose size={20} />
              </button>
            </div>
            <div className="ec-player">
              {demoPlayer.loading ? (
                <div className="ec-empty">Loading video…</div>
              ) : (
                <video src={demoPlayer.src} controls autoPlay />
              )}
            </div>
          </div>
        </div>
      )}

      {/* ================= PDF VIEWER ================= */}
      {pdfViewer && (
        <div className="ec-overlay" onClick={closePdfViewer}>
          <div className="ec-modal ec-modal-player" onClick={(e) => e.stopPropagation()}>
            <div className="ec-modal-header">
              <h3>
                PDF <span className="ec-muted">· {pdfViewer.title}</span>
              </h3>
              <button className="ec-icon-btn" onClick={closePdfViewer} aria-label="Close">
                <IoClose size={20} />
              </button>
            </div>
            <div className="ec-player ec-player-pdf">
              {pdfViewer.loading ? (
                <div className="ec-empty">Loading PDF…</div>
              ) : (
                <iframe src={pdfViewer.src} title={pdfViewer.title} />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EnglishCours;